//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllAnnuityPremium(policyId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AnnuityPremiumListModel[]> {
        let url_ = this.baseUrl + "/api/insured/v{v}/annuitypremiums/policies/{policyId}";
        if (policyId === undefined || policyId === null)
            throw new Error("The parameter 'policyId' must be defined.");
        url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllAnnuityPremium(_response);
        });
    }

    protected processGetAllAnnuityPremium(response: Response): Promise<AnnuityPremiumListModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnnuityPremiumListModel[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAnnuityPremiumById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AnnuityPremiumModel> {
        let url_ = this.baseUrl + "/api/insured/v{v}/annuitypremiums/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAnnuityPremiumById(_response);
        });
    }

    protected processGetAnnuityPremiumById(response: Response): Promise<AnnuityPremiumModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnnuityPremiumModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnnuityPremiumModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createAnnuityPremium(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateAnnuityPremiumModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/insured/v{v}/annuitypremiums";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAnnuityPremium(_response);
        });
    }

    protected processCreateAnnuityPremium(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateAnnuityPremium(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateAnnuityPremiumModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/annuitypremiums";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAnnuityPremium(_response);
        });
    }

    protected processUpdateAnnuityPremium(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteAnnuityPremium(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/annuitypremiums/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAnnuityPremium(_response);
        });
    }

    protected processDeleteAnnuityPremium(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param insuredId (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllInsuredContact(v: string, insuredId?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AllContactResponse> {
        let url_ = this.baseUrl + "/api/insured/v{v}/insuredcontact?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (insuredId === null)
            throw new Error("The parameter 'insuredId' cannot be null.");
        else if (insuredId !== undefined)
            url_ += "insuredId=" + encodeURIComponent("" + insuredId) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllInsuredContact(_response);
        });
    }

    protected processGetAllInsuredContact(response: Response): Promise<AllContactResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AllContactResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AllContactResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createInsuredContact(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateContactRequestModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/insured/v{v}/insuredcontact";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateInsuredContact(_response);
        });
    }

    protected processCreateInsuredContact(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateInsuredContact(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateContactRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/insuredcontact";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateInsuredContact(_response);
        });
    }

    protected processUpdateInsuredContact(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getInsuredContactById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ContactModel> {
        let url_ = this.baseUrl + "/api/insured/v{v}/insuredcontact/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInsuredContactById(_response);
        });
    }

    protected processGetInsuredContactById(response: Response): Promise<ContactModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteInsuredContact(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/insuredcontact/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteInsuredContact(_response);
        });
    }

    protected processDeleteInsuredContact(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getInsuredContactTypes(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/insured/v{v}/insuredcontact/insuredcontacttypes";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInsuredContactTypes(_response);
        });
    }

    protected processGetInsuredContactTypes(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    validatePhoneNumber(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: ValidatePhoneNumberRequest | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/insured/v{v}/insuredcontact/validatephonenumber";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidatePhoneNumber(_response);
        });
    }

    protected processValidatePhoneNumber(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param notDefault (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    insuredMakeDefault(insuredId: number, id: number, contacttypeid: number, v: string, notDefault?: boolean | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/insuredcontact/{insuredId}/contacts/{id}/contacttype/{contacttypeid}/default?";
        if (insuredId === undefined || insuredId === null)
            throw new Error("The parameter 'insuredId' must be defined.");
        url_ = url_.replace("{insuredId}", encodeURIComponent("" + insuredId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (contacttypeid === undefined || contacttypeid === null)
            throw new Error("The parameter 'contacttypeid' must be defined.");
        url_ = url_.replace("{contacttypeid}", encodeURIComponent("" + contacttypeid));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (notDefault === null)
            throw new Error("The parameter 'notDefault' cannot be null.");
        else if (notDefault !== undefined)
            url_ += "notDefault=" + encodeURIComponent("" + notDefault) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsuredMakeDefault(_response);
        });
    }

    protected processInsuredMakeDefault(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param searchType (optional) 
     * @param isSearchInsuredId (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCustomer(v: string, searchType?: number | undefined, isSearchInsuredId?: boolean | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<GetAllCustomerSearchResponse> {
        let url_ = this.baseUrl + "/api/insured/v{v}/customers?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (searchType === null)
            throw new Error("The parameter 'searchType' cannot be null.");
        else if (searchType !== undefined)
            url_ += "SearchType=" + encodeURIComponent("" + searchType) + "&";
        if (isSearchInsuredId === null)
            throw new Error("The parameter 'isSearchInsuredId' cannot be null.");
        else if (isSearchInsuredId !== undefined)
            url_ += "IsSearchInsuredId=" + encodeURIComponent("" + isSearchInsuredId) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllCustomer(_response);
        });
    }

    protected processGetAllCustomer(response: Response): Promise<GetAllCustomerSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAllCustomerSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAllCustomerSearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createCustomer(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateCustomerModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/insured/v{v}/customers";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCustomer(_response);
        });
    }

    protected processCreateCustomer(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateCustomer(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateCustomerModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/customers";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCustomer(_response);
        });
    }

    protected processUpdateCustomer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCustomerById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CustomerDetailModel> {
        let url_ = this.baseUrl + "/api/insured/v{v}/customers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerById(_response);
        });
    }

    protected processGetCustomerById(response: Response): Promise<CustomerDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerDetailModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteCustomer(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/customers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCustomer(_response);
        });
    }

    protected processDeleteCustomer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCustomerDetailById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CustomerDetailByIdModel> {
        let url_ = this.baseUrl + "/api/insured/v{v}/customers/Details/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomerDetailById(_response);
        });
    }

    protected processGetCustomerDetailById(response: Response): Promise<CustomerDetailByIdModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerDetailByIdModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param value (optional) 
     * @param key (optional) 
     * @param isCreateMode (optional) 
     * @param id (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    validateCustomerDetails(v: string, value?: string | null | undefined, key?: string | null | undefined, isCreateMode?: boolean | undefined, id?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ValidateCustomerDetailsResponse> {
        let url_ = this.baseUrl + "/api/insured/v{v}/customers/validatecustomerdetails?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (value !== undefined && value !== null)
            url_ += "Value=" + encodeURIComponent("" + value) + "&";
        if (key !== undefined && key !== null)
            url_ += "Key=" + encodeURIComponent("" + key) + "&";
        if (isCreateMode === null)
            throw new Error("The parameter 'isCreateMode' cannot be null.");
        else if (isCreateMode !== undefined)
            url_ += "IsCreateMode=" + encodeURIComponent("" + isCreateMode) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateCustomerDetails(_response);
        });
    }

    protected processValidateCustomerDetails(response: Response): Promise<ValidateCustomerDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidateCustomerDetailsResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidateCustomerDetailsResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    mergeCustomerPreview(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: MergeCustomerPreviewRequestModel | undefined): Promise<MergeCustomerPreviewResponseModel> {
        let url_ = this.baseUrl + "/api/insured/v{v}/customers/mergecustomerpreview";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMergeCustomerPreview(_response);
        });
    }

    protected processMergeCustomerPreview(response: Response): Promise<MergeCustomerPreviewResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MergeCustomerPreviewResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MergeCustomerPreviewResponseModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    mergeCustomer(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: MergeCustomerPreviewRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/customers/mergecustomer";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMergeCustomer(_response);
        });
    }

    protected processMergeCustomer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param insuredId (optional) 
     * @param status (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllInsuredNotes(v: string, insuredId?: number | undefined, status?: boolean | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<NotesSearchResponse> {
        let url_ = this.baseUrl + "/api/insured/v{v}/insuredNotes?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (insuredId === null)
            throw new Error("The parameter 'insuredId' cannot be null.");
        else if (insuredId !== undefined)
            url_ += "InsuredId=" + encodeURIComponent("" + insuredId) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllInsuredNotes(_response);
        });
    }

    protected processGetAllInsuredNotes(response: Response): Promise<NotesSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotesSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotesSearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    addInsuredNote(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateNoteModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/insured/v{v}/insuredNotes";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddInsuredNote(_response);
        });
    }

    protected processAddInsuredNote(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateInsuredNote(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateNoteModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/insuredNotes";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateInsuredNote(_response);
        });
    }

    protected processUpdateInsuredNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getInsuredNoteById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<NoteModel> {
        let url_ = this.baseUrl + "/api/insured/v{v}/insuredNotes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInsuredNoteById(_response);
        });
    }

    protected processGetInsuredNoteById(response: Response): Promise<NoteModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteInsuredNote(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/insuredNotes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteInsuredNote(_response);
        });
    }

    protected processDeleteInsuredNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllExcessPremium(policyId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ExcessPremiumListModel[]> {
        let url_ = this.baseUrl + "/api/insured/v{v}/excesspremiums/policies/{policyId}";
        if (policyId === undefined || policyId === null)
            throw new Error("The parameter 'policyId' must be defined.");
        url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllExcessPremium(_response);
        });
    }

    protected processGetAllExcessPremium(response: Response): Promise<ExcessPremiumListModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExcessPremiumListModel[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getExcessPremiumById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ExcessPremiumModel> {
        let url_ = this.baseUrl + "/api/insured/v{v}/excesspremiums/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExcessPremiumById(_response);
        });
    }

    protected processGetExcessPremiumById(response: Response): Promise<ExcessPremiumModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExcessPremiumModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteExcessPremium(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/excesspremiums/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteExcessPremium(_response);
        });
    }

    protected processDeleteExcessPremium(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createExcessPremium(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateExcessPremiumModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/insured/v{v}/excesspremiums";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateExcessPremium(_response);
        });
    }

    protected processCreateExcessPremium(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateExcessPremium(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateExcessPremiumModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/excesspremiums";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateExcessPremium(_response);
        });
    }

    protected processUpdateExcessPremium(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param policyStatusId (optional) 
     * @param policyNumber (optional) 
     * @param insuredName (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllPolicy(agentId: number, v: string, companyId?: number | null | undefined, policyStatusId?: number | null | undefined, policyNumber?: string | null | undefined, insuredName?: string | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AllPoliciesByAgentResponse> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/agents/{agentId}?";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (policyStatusId !== undefined && policyStatusId !== null)
            url_ += "PolicyStatusId=" + encodeURIComponent("" + policyStatusId) + "&";
        if (policyNumber !== undefined && policyNumber !== null)
            url_ += "PolicyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        if (insuredName !== undefined && insuredName !== null)
            url_ += "InsuredName=" + encodeURIComponent("" + insuredName) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPolicy(_response);
        });
    }

    protected processGetAllPolicy(response: Response): Promise<AllPoliciesByAgentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AllPoliciesByAgentResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AllPoliciesByAgentResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPolicyById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PolicyByIdResponseModel> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicyById(_response);
        });
    }

    protected processGetPolicyById(response: Response): Promise<PolicyByIdResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PolicyByIdResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deletePolicy(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePolicy(_response);
        });
    }

    protected processDeletePolicy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllPoliciesByCustomer(customerId: number, v: string, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<GetAllPoliciesByCustomerResponse> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/customers/{customerId}?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPoliciesByCustomer(_response);
        });
    }

    protected processGetAllPoliciesByCustomer(response: Response): Promise<GetAllPoliciesByCustomerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAllPoliciesByCustomerResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAllPoliciesByCustomerResponse>(null as any);
    }

    /**
     * @param profileId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getSummaryByProfileId(policyId: number, v: string, profileId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<SummaryModel> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/summary/{policyId}?";
        if (policyId === undefined || policyId === null)
            throw new Error("The parameter 'policyId' must be defined.");
        url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (profileId === null)
            throw new Error("The parameter 'profileId' cannot be null.");
        else if (profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSummaryByProfileId(_response);
        });
    }

    protected processGetSummaryByProfileId(response: Response): Promise<SummaryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SummaryModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SummaryModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPaymentPlanByPolicyId(policyId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PaymentPlanModel> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/paymentplan/{policyId}";
        if (policyId === undefined || policyId === null)
            throw new Error("The parameter 'policyId' must be defined.");
        url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPaymentPlanByPolicyId(_response);
        });
    }

    protected processGetPaymentPlanByPolicyId(response: Response): Promise<PaymentPlanModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentPlanModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getStatusById(policyId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<StatusModel> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/status/{policyId}";
        if (policyId === undefined || policyId === null)
            throw new Error("The parameter 'policyId' must be defined.");
        url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStatusById(_response);
        });
    }

    protected processGetStatusById(response: Response): Promise<StatusModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StatusModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPolicyStatusesLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/statuseslookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicyStatusesLookup(_response);
        });
    }

    protected processGetPolicyStatusesLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param policyNoteTypeId (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllNotesByPolicy(policyId: number, v: string, policyNoteTypeId?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PolicyNoteResponseModel> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/{policyId}/notes?";
        if (policyId === undefined || policyId === null)
            throw new Error("The parameter 'policyId' must be defined.");
        url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (policyNoteTypeId === null)
            throw new Error("The parameter 'policyNoteTypeId' cannot be null.");
        else if (policyNoteTypeId !== undefined)
            url_ += "PolicyNoteTypeId=" + encodeURIComponent("" + policyNoteTypeId) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllNotesByPolicy(_response);
        });
    }

    protected processGetAllNotesByPolicy(response: Response): Promise<PolicyNoteResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PolicyNoteResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyNoteResponseModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getNoteById(noteId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PolicyNoteByIdReponseModel> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/notes/{noteId}";
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNoteById(_response);
        });
    }

    protected processGetNoteById(response: Response): Promise<PolicyNoteByIdReponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PolicyNoteByIdReponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param search (optional) 
     * @param status (optional) 
     * @param searchType (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentsLookUp(v: string, search?: string | null | undefined, status?: string | null | undefined, searchType?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentSearchResponse> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/agentslookup?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (searchType === null)
            throw new Error("The parameter 'searchType' cannot be null.");
        else if (searchType !== undefined)
            url_ += "SearchType=" + encodeURIComponent("" + searchType) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentsLookUp(_response);
        });
    }

    protected processGetAgentsLookUp(response: Response): Promise<AgentSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentSearchResponse>(null as any);
    }

    /**
     * @param policyNumber (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    checkPolicyNumberExists(v: string, policyNumber?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/checkpolicynumber?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (policyNumber !== undefined && policyNumber !== null)
            url_ += "policyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckPolicyNumberExists(_response);
        });
    }

    protected processCheckPolicyNumberExists(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param policyId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPolicyNumber(v: string, policyId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PolicyNumberList[]> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/getpolicynumber?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (policyId === null)
            throw new Error("The parameter 'policyId' cannot be null.");
        else if (policyId !== undefined)
            url_ += "policyId=" + encodeURIComponent("" + policyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicyNumber(_response);
        });
    }

    protected processGetPolicyNumber(response: Response): Promise<PolicyNumberList[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PolicyNumberList[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param agentId (optional) 
     * @param fileType (optional) 
     * @param companyId (optional) 
     * @param statusId (optional) 
     * @param policyNumber (optional) 
     * @param insuredName (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPolicyReport(v: string, agentId?: number | undefined, fileType?: FileType2 | undefined, companyId?: number | undefined, statusId?: number | undefined, policyNumber?: string | null | undefined, insuredName?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/policyreport?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (policyNumber !== undefined && policyNumber !== null)
            url_ += "PolicyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        if (insuredName !== undefined && insuredName !== null)
            url_ += "InsuredName=" + encodeURIComponent("" + insuredName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicyReport(_response);
        });
    }

    protected processGetPolicyReport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param cashWithApp (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCalculatedCommission(v: string, productId?: number | undefined, cashWithApp?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CalculatedCommissionResponse> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/calculatecommission?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (cashWithApp === null)
            throw new Error("The parameter 'cashWithApp' cannot be null.");
        else if (cashWithApp !== undefined)
            url_ += "CashWithApp=" + encodeURIComponent("" + cashWithApp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCalculatedCommission(_response);
        });
    }

    protected processGetCalculatedCommission(response: Response): Promise<CalculatedCommissionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CalculatedCommissionResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalculatedCommissionResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPolicySummaryById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PolicySummaryByIdResponseModel> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/{id}/summary";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicySummaryById(_response);
        });
    }

    protected processGetPolicySummaryById(response: Response): Promise<PolicySummaryByIdResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PolicySummaryByIdResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param searchType (optional) 
     * @param searchText (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllPolicyNumber(v: string, searchType?: number | undefined, searchText?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PolicyNumberResponse> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/policynumber?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (searchType === null)
            throw new Error("The parameter 'searchType' cannot be null.");
        else if (searchType !== undefined)
            url_ += "searchType=" + encodeURIComponent("" + searchType) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPolicyNumber(_response);
        });
    }

    protected processGetAllPolicyNumber(response: Response): Promise<PolicyNumberResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PolicyNumberResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyNumberResponse>(null as any);
    }

    /**
     * @param searchType (optional) 
     * @param searchText (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllInsuredDetails(v: string, searchType?: number | undefined, searchText?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<InsuredDetailsResponse> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/insureddetails?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (searchType === null)
            throw new Error("The parameter 'searchType' cannot be null.");
        else if (searchType !== undefined)
            url_ += "searchType=" + encodeURIComponent("" + searchType) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllInsuredDetails(_response);
        });
    }

    protected processGetAllInsuredDetails(response: Response): Promise<InsuredDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuredDetailsResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuredDetailsResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPolicyLocationLookupByContract(contractId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/{contractId}/locationlookup";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicyLocationLookupByContract(_response);
        });
    }

    protected processGetPolicyLocationLookupByContract(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createPolicy(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdatePolicyModel | undefined): Promise<CreateUpdatePolicyResponse> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePolicy(_response);
        });
    }

    protected processCreatePolicy(response: Response): Promise<CreateUpdatePolicyResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateUpdatePolicyResponse;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateUpdatePolicyResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updatePolicy(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdatePolicyModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePolicy(_response);
        });
    }

    protected processUpdatePolicy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createSummary(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateSummaryModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/summary";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSummary(_response);
        });
    }

    protected processCreateSummary(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateSummary(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateSummaryModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/summary";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSummary(_response);
        });
    }

    protected processUpdateSummary(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createNotes(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdatePolicyNoteModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/notes";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNotes(_response);
        });
    }

    protected processCreateNotes(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateNotes(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdatePolicyNoteModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/notes";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateNotes(_response);
        });
    }

    protected processUpdateNotes(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updatePolicyNumbers(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdatePolicyNumberModel[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/paymentplan/policynumbers";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePolicyNumbers(_response);
        });
    }

    protected processUpdatePolicyNumbers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updatePaymentPlanForPolicy(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdatePaymentPlanModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/paymentplan";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePaymentPlanForPolicy(_response);
        });
    }

    protected processUpdatePaymentPlanForPolicy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    checkRevenueNote(noteId: number, markAsRevenueNote: boolean, policyId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policies/checkrevenuenote/{noteId}/{markAsRevenueNote}/{policyId}";
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        if (markAsRevenueNote === undefined || markAsRevenueNote === null)
            throw new Error("The parameter 'markAsRevenueNote' must be defined.");
        url_ = url_.replace("{markAsRevenueNote}", encodeURIComponent("" + markAsRevenueNote));
        if (policyId === undefined || policyId === null)
            throw new Error("The parameter 'policyId' must be defined.");
        url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckRevenueNote(_response);
        });
    }

    protected processCheckRevenueNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPolicyRenewalById(policyId: number, renewalId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<RenewalDetailModel> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policyrenewals/{policyId}/{renewalId}";
        if (policyId === undefined || policyId === null)
            throw new Error("The parameter 'policyId' must be defined.");
        url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
        if (renewalId === undefined || renewalId === null)
            throw new Error("The parameter 'renewalId' must be defined.");
        url_ = url_.replace("{renewalId}", encodeURIComponent("" + renewalId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicyRenewalById(_response);
        });
    }

    protected processGetPolicyRenewalById(response: Response): Promise<RenewalDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenewalDetailModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenewalDetailModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPolicyRenewalByNumber(policynumber: string | null, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PoliciesForRenewalDetailsModel> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policyrenewals/policiesforrenewal/{policynumber}";
        if (policynumber === undefined || policynumber === null)
            throw new Error("The parameter 'policynumber' must be defined.");
        url_ = url_.replace("{policynumber}", encodeURIComponent("" + policynumber));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicyRenewalByNumber(_response);
        });
    }

    protected processGetPolicyRenewalByNumber(response: Response): Promise<PoliciesForRenewalDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PoliciesForRenewalDetailsModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PoliciesForRenewalDetailsModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    getRenewalFlatRateCalculation(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: RenewalFlatRateCalculationRequest | undefined): Promise<RenewalFlatRateCalculationResponse> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policyrenewals/calculateprorate";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRenewalFlatRateCalculation(_response);
        });
    }

    protected processGetRenewalFlatRateCalculation(response: Response): Promise<RenewalFlatRateCalculationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenewalFlatRateCalculationResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenewalFlatRateCalculationResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRenewalHistory(policyId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<RenewalHistoryListViewModel> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policyrenewals/renewalhistory/{policyId}";
        if (policyId === undefined || policyId === null)
            throw new Error("The parameter 'policyId' must be defined.");
        url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRenewalHistory(_response);
        });
    }

    protected processGetRenewalHistory(response: Response): Promise<RenewalHistoryListViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenewalHistoryListViewModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param fromPolicyId (optional) 
     * @param toPolicyId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    moveRenewal(v: string, fromPolicyId?: number | undefined, toPolicyId?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policyrenewals/moverenewal?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (fromPolicyId === null)
            throw new Error("The parameter 'fromPolicyId' cannot be null.");
        else if (fromPolicyId !== undefined)
            url_ += "FromPolicyId=" + encodeURIComponent("" + fromPolicyId) + "&";
        if (toPolicyId !== undefined && toPolicyId !== null)
            url_ += "ToPolicyId=" + encodeURIComponent("" + toPolicyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMoveRenewal(_response);
        });
    }

    protected processMoveRenewal(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCommissionReceivedByPolicy(policyId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CommissionReceivedByPolicyListModel2[]> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policyrenewals/commissionreceived/{policyId}";
        if (policyId === undefined || policyId === null)
            throw new Error("The parameter 'policyId' must be defined.");
        url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllCommissionReceivedByPolicy(_response);
        });
    }

    protected processGetAllCommissionReceivedByPolicy(response: Response): Promise<CommissionReceivedByPolicyListModel2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommissionReceivedByPolicyListModel2[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param id (optional) 
     * @param policyId (optional) 
     * @param commissionReceived (optional) 
     * @param statementDate (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCommisionReceivedAlreadyExist(v: string, id?: number | undefined, policyId?: number | undefined, commissionReceived?: string | null | undefined, statementDate?: Date | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CommisionReceivedResponse> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policyrenewals/getcommisionreceivedalreadyexist?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (policyId === null)
            throw new Error("The parameter 'policyId' cannot be null.");
        else if (policyId !== undefined)
            url_ += "PolicyId=" + encodeURIComponent("" + policyId) + "&";
        if (commissionReceived !== undefined && commissionReceived !== null)
            url_ += "CommissionReceived=" + encodeURIComponent("" + commissionReceived) + "&";
        if (statementDate === null)
            throw new Error("The parameter 'statementDate' cannot be null.");
        else if (statementDate !== undefined)
            url_ += "StatementDate=" + encodeURIComponent(statementDate ? "" + statementDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommisionReceivedAlreadyExist(_response);
        });
    }

    protected processGetCommisionReceivedAlreadyExist(response: Response): Promise<CommisionReceivedResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommisionReceivedResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommisionReceivedResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createPolicyRenewal(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdatePolicyRenewalDetailModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policyrenewals";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePolicyRenewal(_response);
        });
    }

    protected processCreatePolicyRenewal(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updatePolicyRenewal(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdatePolicyRenewalDetailModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/insured/v{v}/policyrenewals";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePolicyRenewal(_response);
        });
    }

    protected processUpdatePolicyRenewal(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    getPoliciesInfoReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: PoliciesInfoRequest | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/insured/v{v}/reports/policiesinfo";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPoliciesInfoReport(_response);
        });
    }

    protected processGetPoliciesInfoReport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    getPoliciesSummaryReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: PoliciesSummaryRequest | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/insured/v{v}/reports/policiessummary";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPoliciesSummaryReport(_response);
        });
    }

    protected processGetPoliciesSummaryReport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    getTripStandingsReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: TripStandingsRequest | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/insured/v{v}/reports/tripstandings";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTripStandingsReport(_response);
        });
    }

    protected processGetTripStandingsReport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllSingleLifePremium(policyId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<SingleLifePremiumListModel[]> {
        let url_ = this.baseUrl + "/api/insured/v{v}/singlelifepremiums/policies/{policyId}";
        if (policyId === undefined || policyId === null)
            throw new Error("The parameter 'policyId' must be defined.");
        url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllSingleLifePremium(_response);
        });
    }

    protected processGetAllSingleLifePremium(response: Response): Promise<SingleLifePremiumListModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SingleLifePremiumListModel[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getSingleLifePremiumById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<SingleLifePremiumModel> {
        let url_ = this.baseUrl + "/api/insured/v{v}/singlelifepremiums/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSingleLifePremiumById(_response);
        });
    }

    protected processGetSingleLifePremiumById(response: Response): Promise<SingleLifePremiumModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SingleLifePremiumModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteSingleLifePremium(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/singlelifepremiums/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteSingleLifePremium(_response);
        });
    }

    protected processDeleteSingleLifePremium(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createSingleLifePremium(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateSingleLifePremiumModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/insured/v{v}/singlelifepremiums";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSingleLifePremium(_response);
        });
    }

    protected processCreateSingleLifePremium(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateSingleLifePremium(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateSingleLifePremiumModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/insured/v{v}/singlelifepremiums";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSingleLifePremium(_response);
        });
    }

    protected processUpdateSingleLifePremium(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param tripCategoryId (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllTripPointsByAgent(agentId: number, startDate: Date, endDate: Date, v: string, tripCategoryId?: number | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<TripPointsByAgentSearchResponse> {
        let url_ = this.baseUrl + "/api/insured/v{v}/trippoints/agents?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined and cannot be null.");
        else
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tripCategoryId !== undefined && tripCategoryId !== null)
            url_ += "TripCategoryId=" + encodeURIComponent("" + tripCategoryId) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllTripPointsByAgent(_response);
        });
    }

    protected processGetAllTripPointsByAgent(response: Response): Promise<TripPointsByAgentSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TripPointsByAgentSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TripPointsByAgentSearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllTripPointsByPolicyId(policyId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<TripPointsPolicySPModel> {
        let url_ = this.baseUrl + "/api/insured/v{v}/trippoints/policies/{policyId}";
        if (policyId === undefined || policyId === null)
            throw new Error("The parameter 'policyId' must be defined.");
        url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllTripPointsByPolicyId(_response);
        });
    }

    protected processGetAllTripPointsByPolicyId(response: Response): Promise<TripPointsPolicySPModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TripPointsPolicySPModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param policyIds (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllTripPointsByPolicies(v: string, policyIds?: number[] | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<TripPointsByPoliciesSearchResponse> {
        let url_ = this.baseUrl + "/api/insured/v{v}/trippoints/policies?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (policyIds !== undefined && policyIds !== null)
            policyIds && policyIds.forEach(item => { url_ += "PolicyIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllTripPointsByPolicies(_response);
        });
    }

    protected processGetAllTripPointsByPolicies(response: Response): Promise<TripPointsByPoliciesSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TripPointsByPoliciesSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TripPointsByPoliciesSearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getTripCategory(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/insured/v{v}/trippoints/tripcategory";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTripCategory(_response);
        });
    }

    protected processGetTripCategory(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }
}

export interface AnnuityPremiumListModel {
    id?: number;
    policyId?: number;
    amount?: number;
    initialDeposit?: boolean;
    date?: Date;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface AnnuityPremiumModel {
    id?: number;
    policyId?: number;
    amount?: number;
    initialDeposit?: boolean;
    date?: Date;
}

export interface CreateUpdateAnnuityPremiumModel {
    id?: number;
    policyId?: number;
    amount?: number;
    initialDeposit?: boolean;
    date?: Date;
}

export interface ContactModel {
    insuredId?: number;
    id?: number;
    default?: boolean;
    commission?: boolean;
    contactType?: string | undefined;
    contactTypeId?: number;
    contactValue?: string | undefined;
    description?: string | undefined;
    createdByUserId?: number;
    dateCreated?: Date;
    enableSMS?: boolean;
    phoneTypeId?: number;
    emailTypeId?: number;
    category?: string | undefined;
}

export interface AllContactResponse {
    recordCount?: number;
    data?: ContactModel[] | undefined;
}

export interface CreateUpdateContactRequestModel {
    id?: number;
    contactTypeId?: number;
    contactValue?: string | undefined;
    description?: string | undefined;
    insuredId?: number;
    createdByUserId?: number;
    dateCreated?: Date;
    enableSMS?: boolean;
    phoneTypeId?: number | undefined;
    emailTypeId?: number | undefined;
    default?: boolean;
}

export interface ListItem {
    value?: string | undefined;
    text?: string | undefined;
    selected?: boolean;
}

export interface ValidatePhoneNumberRequest {
    contactTypeId?: number;
    contactValue?: string | undefined;
    phoneTypeId?: number | undefined;
}

export interface CustomerSearchListModel {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dob?: Date | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    countyName?: string | undefined;
    middleInitial?: string | undefined;
}

export interface GetAllCustomerSearchResponse {
    recordCount?: number;
    data?: CustomerSearchListModel[] | undefined;
}

export interface CustAttrToEntityModel {
    customAttributeScreenId?: number;
    entityId?: number;
    value?: string | undefined;
}

export interface CreateUpdateCustomerModel {
    id?: number;
    lName?: string | undefined;
    fName?: string | undefined;
    mi?: string | undefined;
    suffix?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    countyName?: string | undefined;
    bDay?: Date;
    ssn?: string | undefined;
    hicn?: string | undefined;
    isEmployee?: boolean;
    payorName?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    medicareBeneficiaryIdentificationNumber?: string | undefined;
    ignoreNameValidation?: boolean;
    gender?: string | undefined;
    medicaidNumber?: string | undefined;
    subsidyLevelId?: number | undefined;
    statePharmaceuticalProgramMemberNumber?: string | undefined;
    contactList?: CreateUpdateContactRequestModel[] | undefined;
    customAttributes?: CustAttrToEntityModel[] | undefined;
}

export interface StateListItem {
    stateId?: number;
    stateName?: string | undefined;
    abbreviation?: string | undefined;
    selected?: boolean;
    isHeader?: boolean;
}

export interface AlternateCounty {
    countyName?: string | undefined;
}

export interface LongRunningMarketingEventGroup {
    id?: number;
    name?: string | undefined;
    marketingEvent?: MarketingEvent[] | undefined;
}

export interface MarketingEventType {
    id?: number;
    marketingEventTypeName?: string | undefined;
    marketingEvent?: MarketingEvent[] | undefined;
}

export interface MarketingFormat {
    id?: number;
    marketingFormatName?: string | undefined;
    marketingEvent?: MarketingEvent[] | undefined;
}

export interface EmailDomain {
    id?: number;
    domain?: string | undefined;
    isExcludedFromReports?: boolean | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    emailAddress?: EmailAddress[] | undefined;
}

export interface EmailAddress {
    id?: number;
    address?: string | undefined;
    emailDomainId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    emailDomain?: EmailDomain;
    marketingEventEmail?: MarketingEventEmail[] | undefined;
}

export interface MarketingEventEmail {
    id?: number;
    emailAddressId?: number;
    marketingEventEmailListId?: number;
    sent?: boolean | undefined;
    sentTime?: Date | undefined;
    canSend?: boolean;
    statusMessage?: string | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    emailAddress?: EmailAddress;
    marketingEventEmailList?: MarketingEventEmailList;
}

export interface MarketingEventEmailList {
    id?: number;
    dateStart?: Date;
    userId?: number;
    dateEnd?: Date;
    marketingEventId?: number;
    sent?: boolean;
    listName?: string | undefined;
    isPaused?: boolean;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    marketingEvent?: MarketingEvent;
    marketingEventEmail?: MarketingEventEmail[] | undefined;
}

export interface MarketingEvent {
    id?: number;
    marketingEventTypeId?: number;
    marketingFormatId?: number;
    ownerId?: number;
    companyId?: number;
    divisionId?: number;
    dateTimeStart?: Date;
    dateTimeEnd?: Date;
    title?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    audience?: string | undefined;
    requestorId?: number | undefined;
    audienceSize?: number | undefined;
    purchasedLead?: boolean | undefined;
    emailSubject?: string | undefined;
    fromEmailAddress?: string | undefined;
    fromDisplayName?: string | undefined;
    replyTo?: string | undefined;
    longRunningMarketingEventGroupId?: number | undefined;
    productLineId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    longRunningMarketingEventGroup?: LongRunningMarketingEventGroup;
    marketingEventType?: MarketingEventType;
    marketingFormat?: MarketingFormat;
    calllist?: Calllist[] | undefined;
    marketingEventEmailList?: MarketingEventEmailList[] | undefined;
}

export interface Calllist {
    id?: number;
    teamId?: number;
    calllistName?: string | undefined;
    userId?: number;
    createdDate?: Date;
    prospective?: boolean;
    exist?: boolean | undefined;
    marketingEventId?: number | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    marketingEvent?: MarketingEvent;
    users?: Users[] | undefined;
}

export interface Bank {
    bankId?: number;
    routingNumber?: string | undefined;
    bankName?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    bankAccounts?: BankAccounts[] | undefined;
}

export interface BankAccountPaymentMethod {
    bankAccountPaymentMethodId?: number;
    bankAccountPaymentMethodName?: string | undefined;
    sort?: number | undefined;
    bankAccounts?: BankAccounts[] | undefined;
}

export interface BankAccountType {
    bankAccountTypeId?: number;
    bankAccountTypeName?: string | undefined;
    bankAccounts?: BankAccounts[] | undefined;
}

export interface AgentDebt {
    agentDebtId?: number;
    createdDateTime?: Date;
    createdByUserId?: number;
    agentId?: number;
    companyId?: number;
    reportDate?: Date;
    advanced?: number;
    unsecured?: number;
    reserve?: number;
    side?: number;
    rollup?: number;
    producerWeek?: number;
    uplineWeek?: number;
    writingNumber?: string | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    company?: Company;
}

export interface LicensePersistency {
    licensePersistencyId?: number;
    licenseId?: number;
    licensePersistencyTypeId?: number;
    createdDateTime?: Date;
    persistencyPercentage?: number;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    license?: License;
    licensePersistencyType?: LicensePersistencyType;
}

export interface LicensePersistencyTypeColoringRule {
    licensePersistencyTypeColoringRuleId?: number;
    licensePersistencyTypeId?: number;
    hexColor?: string | undefined;
    startRange?: number;
    stopRange?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    licensePersistencyType?: LicensePersistencyType;
}

export interface LicensePersistencyType {
    licensePersistencyTypeId?: number;
    companyId?: number;
    licensePersistencyTypeName?: string | undefined;
    sortOrder?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    company?: Company;
    licensePersistency?: LicensePersistency[] | undefined;
    licensePersistencyTypeColoringRule?: LicensePersistencyTypeColoringRule[] | undefined;
}

export interface SubmissionRequirementRulesetFilterCompany {
    submissionRequirementRulesetFilterCompanyId?: number;
    submissionRequirementRulesetId?: number;
    companyId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    company?: Company;
    createdByUser?: Users;
    submissionRequirementRuleset?: SubmissionRequirementRuleset;
}

export interface SubmissionRequirementRulesetFilterPolicyEffectiveDateYear {
    submissionRequirementRulesetFilterPolicyEffectiveDateYearId?: number;
    submissionRequirementRulesetId?: number;
    policyEffectiveDateYear?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    submissionRequirementRuleset?: SubmissionRequirementRuleset;
}

export interface TblProductCategory {
    id?: number;
    productCategoryName?: string | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    tblProductSubCategory?: TblProductSubCategory[] | undefined;
}

export interface AgentProductLine {
    id?: number;
    agentId?: number;
    productLineId?: number;
    contracted?: boolean;
    active?: boolean;
    referred?: boolean;
    dateCreated?: Date;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    productLine?: TblProductLine;
}

export interface AgentContactEmailUnsubscribe {
    id?: number;
    emailId?: string | undefined;
    productLineID?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    productLine?: TblProductLine;
}

export interface TblProductLine {
    id?: number;
    productLineName?: string | undefined;
    isMarketerHierarchyBased?: boolean;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agentProductLine?: AgentProductLine[] | undefined;
    tblProductSubCategory?: TblProductSubCategory[] | undefined;
    agentContactEmailUnsubscribe?: AgentContactEmailUnsubscribe[] | undefined;
}

export interface SubmissionAutoUncheckRulesetFilterProductSubcategory {
    submissionAutoUncheckRulesetFilterProductSubcategoryId?: number;
    submissionAutoUncheckRulesetId?: number;
    productSubcategoryId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    productSubcategory?: TblProductSubCategory;
    submissionAutoUncheckRuleset?: SubmissionAutoUncheckRuleset;
}

export interface SubmissionRequirementRulesetFilterProductSubcategory {
    submissionRequirementRulesetFilterProductSubcategoryId?: number;
    submissionRequirementRulesetId?: number;
    productSubcategoryId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    productSubcategory?: TblProductSubCategory;
    submissionRequirementRuleset?: SubmissionRequirementRuleset;
}

export interface SubmissionSenderTypeEmail {
    submissionSenderTypeEmailId?: number;
    submissionSenderTypeEmailName?: string | undefined;
    fromEmailAddress?: string | undefined;
    dateTimeCreated?: Date;
    dateTimeModified?: Date | undefined;
    createdByUserId?: number;
    modifiedByUserId?: number | undefined;
    createdByUser?: Users;
    modifiedByUser?: Users;
    submissionRulesetConnectorTypeEmail?: SubmissionRulesetConnectorTypeEmail[] | undefined;
}

export interface SubmissionTypeEmail {
    submissionTypeEmailId?: number;
    submissionTypeEmailName?: string | undefined;
    toEmailAddress?: string | undefined;
    sendAsSecureEmail?: boolean;
    isDisabled?: boolean;
    dateTimeCreated?: Date;
    dateTimeModified?: Date | undefined;
    createdByUserId?: number;
    modifiedByUserId?: number | undefined;
    createdByUser?: Users;
    modifiedByUser?: Users;
    submissionRulesetConnectorTypeEmail?: SubmissionRulesetConnectorTypeEmail[] | undefined;
}

export interface SubmissionRulesetConnectorTypeEmail {
    submissionRulesetConnectorTypeEmailId?: number;
    submissionRulesetId?: number;
    submissionTypeEmailId?: number;
    submissionSenderTypeEmailId?: number;
    fileName?: string | undefined;
    priority?: number;
    dateTimeCreated?: Date;
    dateTimeModified?: Date | undefined;
    createdByUserId?: number;
    modifiedByUserId?: number | undefined;
    createdByUser?: Users;
    modifiedByUser?: Users;
    submissionRuleset?: SubmissionRuleset;
    submissionSenderTypeEmail?: SubmissionSenderTypeEmail;
    submissionTypeEmail?: SubmissionTypeEmail;
}

export interface SubmissionTypeFtp {
    submissionTypeFtpid?: number;
    submissionTypeFtpname?: string | undefined;
    server?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    port?: number;
    ftptype?: number;
    isDisabled?: boolean;
    dateTimeCreated?: Date;
    dateTimeModified?: Date | undefined;
    createdByUserId?: number;
    modifiedByUserId?: number | undefined;
    createdByUser?: Users;
    modifiedByUser?: Users;
    submissionRulesetConnectorTypeFtp?: SubmissionRulesetConnectorTypeFtp[] | undefined;
}

export interface SubmissionRulesetConnectorTypeFtp {
    submissionRulesetConnectorTypeFtpid?: number;
    submissionRulesetId?: number;
    submissionTypeFtpid?: number;
    filePath?: string | undefined;
    fileName?: string | undefined;
    priority?: number;
    dateTimeCreated?: Date;
    dateTimeModified?: Date | undefined;
    createdByUserId?: number;
    modifiedByUserId?: number | undefined;
    createdByUser?: Users;
    modifiedByUser?: Users;
    submissionRuleset?: SubmissionRuleset;
    submissionTypeFtp?: SubmissionTypeFtp;
}

export interface SubmissionRulesetFilterCompany {
    submissionRulesetFilterCompanyId?: number;
    submissionRulesetId?: number;
    companyId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    company?: Company;
    createdByUser?: Users;
    submissionRuleset?: SubmissionRuleset;
}

export interface SubmissionRulesetFilterDocumentType {
    submissionRulesetFilterDocumentTypeId?: number;
    submissionRulesetId?: number;
    documentTypeId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    documentType?: FileType;
    submissionRuleset?: SubmissionRuleset;
}

export interface SubmissionRulesetFilterPolicyEffectiveDateYear {
    submissionRulesetFilterPolicyEffectiveDateYearId?: number;
    submissionRulesetId?: number;
    policyEffectiveDateYear?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    submissionRuleset?: SubmissionRuleset;
}

export interface SubmissionRulesetFilterProduct {
    submissionRulesetFilterProductId?: number;
    submissionRulesetId?: number;
    productId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    product?: TblProduct;
    submissionRuleset?: SubmissionRuleset;
}

export interface OrdersDetails {
    id?: number;
    orderId?: number;
    supplyId?: number;
    qty?: number;
    qtySent?: number | undefined;
    comment?: string | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    orderDetailState?: OrderDetailState[] | undefined;
}

export interface OrderDetailState {
    orderDetailStateId?: number;
    orderDetailId?: number;
    stateId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    orderDetail?: OrdersDetails;
    state?: TblState;
}

export interface SubmissionAutoUncheckRulesetFilterState {
    submissionAutoUncheckRulesetFilterStateId?: number;
    submissionAutoUncheckRulesetId?: number;
    stateId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    state?: TblState;
    submissionAutoUncheckRuleset?: SubmissionAutoUncheckRuleset;
}

export interface SubmissionRequirementRulesetFilterState {
    submissionRequirementRulesetFilterStateId?: number;
    submissionRequirementRulesetId?: number;
    stateId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    state?: TblState;
    submissionRequirementRuleset?: SubmissionRequirementRuleset;
}

export interface LicenseNumberState {
    id?: number;
    licenseNumberId?: number;
    stateId?: number;
    state?: TblState;
}

export interface LicenseStates {
    id?: number;
    licenseId?: number;
    stateId?: number;
    apptDate?: Date | undefined;
    termDate?: Date | undefined;
    dateCreated?: Date;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    license?: License;
    state?: TblState;
}

export interface TblProductType {
    id?: number;
    productType?: string | undefined;
    supplies?: Supplies[] | undefined;
}

export interface Supplies {
    id?: number;
    productTypeId?: number;
    companyId?: number;
    itemNumber?: string | undefined;
    itemDescription?: string | undefined;
    reOrderLevel?: number;
    active?: boolean | undefined;
    onOrderCount?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    productType?: TblProductType;
    suppliesStates?: SuppliesStates[] | undefined;
}

export interface SuppliesStates {
    id?: number;
    stateId?: number;
    supplyId?: number;
    notes?: string | undefined;
    reOrderLevel?: number | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    state?: TblState;
    supply?: Supplies;
}

export interface TblState {
    id?: number;
    state?: string | undefined;
    stateName?: string | undefined;
    isTerritories?: boolean | undefined;
    orderDetailState?: OrderDetailState[] | undefined;
    submissionAutoUncheckRulesetFilterState?: SubmissionAutoUncheckRulesetFilterState[] | undefined;
    submissionRequirementRulesetFilterState?: SubmissionRequirementRulesetFilterState[] | undefined;
    submissionRulesetFilterState?: SubmissionRulesetFilterState[] | undefined;
    licenseNumberState?: LicenseNumberState[] | undefined;
    licenseStates?: LicenseStates[] | undefined;
    suppliesStates?: SuppliesStates[] | undefined;
}

export interface SubmissionRulesetFilterState {
    submissionRulesetFilterStateId?: number;
    submissionRulesetId?: number;
    stateId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    state?: TblState;
    submissionRuleset?: SubmissionRuleset;
}

export interface SubmissionRuleset {
    submissionRulesetId?: number;
    submissionRulesetName?: string | undefined;
    submissionRulesetType?: number;
    priority?: number;
    dateTimeCreated?: Date;
    dateTimeModified?: Date | undefined;
    createdByUserId?: number;
    modifiedByUserId?: number | undefined;
    createdByUser?: Users;
    modifiedByUser?: Users;
    submissionRulesetConnectorTypeEmail?: SubmissionRulesetConnectorTypeEmail[] | undefined;
    submissionRulesetConnectorTypeFtp?: SubmissionRulesetConnectorTypeFtp[] | undefined;
    submissionRulesetFilterCompany?: SubmissionRulesetFilterCompany[] | undefined;
    submissionRulesetFilterDocumentType?: SubmissionRulesetFilterDocumentType[] | undefined;
    submissionRulesetFilterPolicyEffectiveDateYear?: SubmissionRulesetFilterPolicyEffectiveDateYear[] | undefined;
    submissionRulesetFilterProduct?: SubmissionRulesetFilterProduct[] | undefined;
    submissionRulesetFilterProductSubcategory?: SubmissionRulesetFilterProductSubcategory[] | undefined;
    submissionRulesetFilterState?: SubmissionRulesetFilterState[] | undefined;
}

export interface SubmissionRulesetFilterProductSubcategory {
    submissionRulesetFilterProductSubcategoryId?: number;
    submissionRulesetId?: number;
    productSubcategoryId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    productSubcategory?: TblProductSubCategory;
    submissionRuleset?: SubmissionRuleset;
}

export interface TblProductSubCategory {
    id?: number;
    subCategoryName?: string | undefined;
    categoryId?: number;
    isProRateable?: boolean;
    isEnrollment?: boolean;
    productClass?: string | undefined;
    productTypeCode?: string | undefined;
    productLineId?: number;
    marginFactor?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    category?: TblProductCategory;
    productLine?: TblProductLine;
    submissionAutoUncheckRulesetFilterProductSubcategory?: SubmissionAutoUncheckRulesetFilterProductSubcategory[] | undefined;
    submissionRequirementRulesetFilterProductSubcategory?: SubmissionRequirementRulesetFilterProductSubcategory[] | undefined;
    submissionRulesetFilterProductSubcategory?: SubmissionRulesetFilterProductSubcategory[] | undefined;
    tblProduct?: TblProduct[] | undefined;
}

export interface SubmissionAutoUncheckRulesetFilterProduct {
    submissionAutoUncheckRulesetFilterProductId?: number;
    submissionAutoUncheckRulesetId?: number;
    productId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    product?: TblProduct;
    submissionAutoUncheckRuleset?: SubmissionAutoUncheckRuleset;
}

export interface Certification {
    id?: number;
    agentId?: number;
    productId?: number;
    certificationDate?: Date;
    certificationYear?: number;
    override?: boolean;
    companyId?: number;
    dateCreated?: Date;
    createdByUserId?: number;
    note?: string | undefined;
    vueExportFileDateTime?: Date | undefined;
    timestamp?: string | undefined;
    recordStatus?: boolean | undefined;
    newRecord?: boolean | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    createdByUser?: Users;
    product?: TblProduct;
}

export interface TblLevelMarketer {
    id?: number;
    levelId?: number;
    marketerId?: number;
    priority?: number;
    split?: number;
    dateCreated?: Date;
    vueExportFileDateTime?: Date | undefined;
    timestamp?: string | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    level?: TblLevel;
    marketer?: Agents;
}

export interface CommissionPaymentMethod {
    id?: number;
    paymentMethodName?: string | undefined;
    commPlan?: CommPlan[] | undefined;
}

export interface TblPaymentSource {
    id?: number;
    paymentSource?: string | undefined;
    commPlan?: CommPlan[] | undefined;
    profile?: Profile[] | undefined;
}

export interface RenewalAge {
    id?: number;
    planId?: number | undefined;
    age1?: number | undefined;
    age2?: number | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    plan?: CommPlan;
}

export interface CommPlan {
    id?: number;
    companyId?: number;
    name?: string | undefined;
    description?: string | undefined;
    status?: number;
    paymentSourceId?: number;
    paymentMethodId?: number;
    alwaysShow?: boolean;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    paymentMethod?: CommissionPaymentMethod;
    paymentSource?: TblPaymentSource;
    profile?: Profile[] | undefined;
    renewalAge?: RenewalAge[] | undefined;
}

export interface PolicyRating {
    id?: number;
    rating?: string | undefined;
    isDefault?: boolean;
    policyAppliedRating?: Policy[] | undefined;
    policyApprovedRating?: Policy[] | undefined;
}

export interface Modes {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    factor?: number;
    policy?: Policy[] | undefined;
}

export interface PolicyStatus {
    id?: number;
    status?: string | undefined;
    code?: string | undefined;
    policy?: Policy[] | undefined;
}

export interface PolicyNumbers {
    policyNumberId?: number;
    policyId?: number;
    policyNumber?: string | undefined;
    createdByUserId?: number;
    createdDateTime?: Date;
    isValid?: boolean;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    policy?: Policy;
}

export interface PolicyAnnuity {
    id?: number;
    policyId?: number;
    date?: Date;
    amount?: number;
    initialDeposit?: boolean;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    policy?: Policy;
}

export interface PolicyExcess {
    id?: number;
    policyId?: number;
    date?: Date;
    amount?: number;
    override?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    policy?: Policy;
}

export interface PolicyNoteType {
    id?: number;
    policyNoteTypeName?: string | undefined;
    policyNote?: PolicyNote[] | undefined;
}

export interface PolicyNote {
    id?: number;
    policyId?: number;
    userId?: number;
    noteDate?: Date;
    note?: string | undefined;
    private?: boolean;
    policyNoteTypeId?: number;
    revenueNote?: boolean | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    policy?: Policy;
    policyNoteType?: PolicyNoteType;
}

export interface PolicySingleLife {
    id?: number;
    policyId?: number;
    date?: Date;
    amount?: number;
    override?: number;
    dateCreated?: Date | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdBy?: number | undefined;
    policy?: Policy;
}

export interface MarketingUnsubscribe {
    id?: number;
    agentId?: number | undefined;
    divisionId?: number;
    emailAddress?: string | undefined;
    dateCreated?: Date;
    marketingEventId?: number | undefined;
    division?: Division;
}

export interface CompanyAddresses {
    id?: number;
    companyId?: number;
    addressName?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    zipCode?: string | undefined;
    cityName?: string | undefined;
    stateAbbreviation?: string | undefined;
    countyName?: string | undefined;
    addressType?: number;
    dateCreated?: Date;
    userId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    addressTypeNavigation?: TblAddressType;
    company?: Company;
    user?: Users;
}

export interface TblAddressType {
    id?: number;
    addressType?: string | undefined;
    isHidden?: boolean;
    isHiddenForCarrier?: boolean;
    addresses?: Addresses[] | undefined;
    companyAddresses?: CompanyAddresses[] | undefined;
}

export interface AgentToAddress {
    agentId?: number;
    addressId?: number;
    address?: Addresses;
    agent?: Agents;
}

export interface Addresses {
    id?: number;
    addressName?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    lastLine?: string | undefined;
    zipCode?: string | undefined;
    addressee?: string | undefined;
    firmName?: string | undefined;
    deliveryPointBarcode?: string | undefined;
    visibleInUpline?: boolean;
    visibleInDownline?: boolean;
    securityAccessCode?: string | undefined;
    addressType?: number | undefined;
    visible?: boolean;
    dateCreated?: Date;
    userId?: number;
    urbanization?: string | undefined;
    primaryNumber?: string | undefined;
    streetName?: string | undefined;
    streetPredirection?: string | undefined;
    streetPostdirection?: string | undefined;
    streetSuffix?: string | undefined;
    secondaryNumber?: string | undefined;
    secondaryDesignator?: string | undefined;
    extraSecondaryNumber?: string | undefined;
    extraSecondaryDesignator?: string | undefined;
    pmbDesignator?: string | undefined;
    pmbNumber?: string | undefined;
    cityName?: string | undefined;
    defaultCityName?: string | undefined;
    stateAbbreviation?: string | undefined;
    plusFourCode?: string | undefined;
    deliveryPoint?: string | undefined;
    deliveryPointCheckDigit?: string | undefined;
    recordType?: string | undefined;
    zipType?: string | undefined;
    countyFips?: string | undefined;
    countyName?: string | undefined;
    carrierRoute?: string | undefined;
    congressionalDistrict?: string | undefined;
    buildingDefaultIndicator?: string | undefined;
    rdi?: string | undefined;
    elotSequence?: string | undefined;
    elotSort?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    precision?: string | undefined;
    dpvCmra?: string | undefined;
    dpvVacant?: string | undefined;
    active?: string | undefined;
    ewsMatch?: string | undefined;
    footnotes?: string | undefined;
    lacslinkCode?: string | undefined;
    lacslinkIndicator?: string | undefined;
    suitelinkMatch?: string | undefined;
    dpvMatchCode?: string | undefined;
    dpvFootnotes?: string | undefined;
    addressComments?: string | undefined;
    isValid?: boolean;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    addressTypeNavigation?: TblAddressType;
    agentToAddress?: AgentToAddress[] | undefined;
    orders?: Orders[] | undefined;
}

export interface ShippingMethod {
    id?: number;
    method?: string | undefined;
    orders?: Orders[] | undefined;
}

export interface Orders {
    id?: number;
    agentId?: number;
    userId?: number;
    shippingMethodId?: number | undefined;
    orderTakenByUserId?: number;
    orderDate?: Date;
    comments?: string | undefined;
    completed?: boolean;
    addressId?: number;
    completedDate?: Date | undefined;
    trackingNumber?: string | undefined;
    weight?: number | undefined;
    shippingDate?: Date | undefined;
    fee?: number | undefined;
    departmentId?: number | undefined;
    printedDate?: Date | undefined;
    divisionId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    address?: Addresses;
    division?: Division;
    orderTakenByUser?: Users;
    shippingMethod?: ShippingMethod;
}

export interface Revenue {
    id?: number;
    companyId?: number;
    paidDivisionId?: number;
    statementDate?: Date;
    amount?: number;
    comment?: string | undefined;
    createdByUserId?: number;
    dateCreated?: Date;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    paidDivision?: Division;
}

export interface UserManageTeam {
    id?: number;
    userId?: number;
    teamId?: number;
    team?: UserTeam;
    user?: Users;
}

export interface UserTeamAgencyId {
    id?: number;
    teamId?: number;
    premierId?: number;
    premier?: Agents;
    team?: UserTeam;
}

export interface UserTeam {
    id?: number;
    divisionId?: number;
    teamName?: string | undefined;
    includeInReport?: boolean;
    includeInWorkflow?: boolean;
    allowAccesstoPasswordList?: boolean | undefined;
    marketerId?: number | undefined;
    phoneExtension?: number | undefined;
    color?: number;
    managerId?: number | undefined;
    reportColor?: string | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    division?: Division;
    marketer?: Agents;
    tblDocument?: TblDocument[] | undefined;
    userManageTeam?: UserManageTeam[] | undefined;
    userTeamAgencyId?: UserTeamAgencyId[] | undefined;
}

export interface Division {
    id?: number;
    divisionName?: string | undefined;
    divisionGroupId?: number | undefined;
    abbreviation?: string | undefined;
    commissionRunBatches?: CommissionRunBatches[] | undefined;
    marketingUnsubscribe?: MarketingUnsubscribe[] | undefined;
    orders?: Orders[] | undefined;
    revenue?: Revenue[] | undefined;
    userTeam?: UserTeam[] | undefined;
}

export interface RenewalCommissions {
    id?: number;
    agentId?: number;
    writingAgentId?: number;
    payToId?: number;
    agentName?: string | undefined;
    policyOrig?: string | undefined;
    premium?: number;
    commission?: number;
    rate?: number;
    dateCreated?: Date;
    overwrite?: boolean;
    customer?: string | undefined;
    policyTypeBase?: string | undefined;
    issueDate?: Date | undefined;
    writingAgentNumber?: string | undefined;
    advance?: string | undefined;
    refund?: string | undefined;
    duration?: number;
    paid?: boolean;
    payToName?: string | undefined;
    rateReduced?: boolean;
    datePaid?: Date | undefined;
    renewalType?: number;
    effectiveDate?: Date | undefined;
    processingCompanyId?: number;
    issueAge?: number;
    companyId?: number;
    userId?: number;
    batchId?: number | undefined;
    commissionPayFromId?: number | undefined;
    policy?: string | undefined;
    policyEffectiveDate?: Date | undefined;
    paymentSource?: string | undefined;
    flatRateAmount?: number;
    flatRateFactor?: number;
    renewalId?: number | undefined;
    policyId?: number;
    transactionId?: number | undefined;
    hidePremiumAndRate?: boolean;
    hideAllExceptAmount?: boolean;
    pdfgenerated?: boolean;
    excelGenerated?: boolean;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    batch?: CommissionRunBatches;
    payTo?: Agents;
    policyNavigation?: Policy;
}

export interface CommissionRunBatches {
    id?: number;
    batchName?: string | undefined;
    payDate?: Date;
    userId?: number;
    divisionId?: number;
    approved?: boolean;
    paid?: boolean;
    pdfgenerated?: boolean;
    excelGenerated?: boolean;
    companyId?: number | undefined;
    totalCount?: number | undefined;
    processedCount?: number | undefined;
    failedCount?: number | undefined;
    notificationSent?: boolean;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    company?: Company;
    division?: Division;
    user?: Users;
    renewal?: Renewal[] | undefined;
    renewalCommissions?: RenewalCommissions[] | undefined;
}

export interface Renewal {
    id?: number;
    payToId?: number;
    code?: string | undefined;
    firstInitial?: string | undefined;
    lastName?: string | undefined;
    policyTypeBase?: string | undefined;
    mode?: string | undefined;
    premium?: number;
    issueDate?: Date | undefined;
    conversionFlag?: string | undefined;
    advanceFlag?: string | undefined;
    endMonth?: number;
    writingAgent?: string | undefined;
    company?: number | undefined;
    commPlanId?: number | undefined;
    renewalIssueAge?: number;
    renewalComplete?: boolean;
    productId?: number | undefined;
    policyId?: number | undefined;
    renewalType?: number | undefined;
    createDate?: Date | undefined;
    userId?: number | undefined;
    dateCreated?: Date | undefined;
    policy?: string | undefined;
    paymentSource?: string | undefined;
    flatRateFactor?: number | undefined;
    premiumOverride?: number | undefined;
    batchId?: number | undefined;
    rowVersion?: string | undefined;
    isProcessed?: boolean;
    statementDate?: Date | undefined;
    commissionReceived?: number | undefined;
    commissionPayable?: number | undefined;
    payeesOnPlan?: number | undefined;
    commissionPlanPayees?: string | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    batch?: CommissionRunBatches;
    policyNavigation?: Policy;
}

export interface AgentNoteType {
    id?: number;
    agentNoteTypeName?: string | undefined;
    agentNotes?: AgentNotes[] | undefined;
}

export interface PayoutLevelType {
    id?: number;
    type?: string | undefined;
    payoutLevel?: PayoutLevel[] | undefined;
}

export interface PayoutLevel {
    id?: number;
    companyId?: number;
    productId?: number | undefined;
    docId?: number | undefined;
    description?: string | undefined;
    internalOnly?: boolean | undefined;
    commission?: number | undefined;
    dateCreated?: Date;
    createUserId?: number;
    hidden?: boolean | undefined;
    companyRoleId?: number | undefined;
    compensationLevel?: string | undefined;
    rank?: number | undefined;
    typeId?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createUser?: Users;
    agentNotes?: AgentNotes[] | undefined;
    payoutLevelType?: PayoutLevelType;
    levels?: TblLevel[] | undefined;
}

export interface SalesType {
    salesTypeId?: number;
    salesTypeName?: string | undefined;
    agentNotes?: AgentNotes[] | undefined;
    license?: License[] | undefined;
}

export interface AgentNotes {
    id?: number;
    agentId?: number;
    user?: string | undefined;
    dateTime?: Date;
    note?: string | undefined;
    userId?: number;
    companyId?: number | undefined;
    payoutLevelId?: number | undefined;
    private?: boolean;
    ignore?: boolean;
    color?: number;
    agentNoteTypeId?: number;
    hierarchyPremierId?: number | undefined;
    transferFromOtherFmo?: boolean;
    salesTypeId?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    pinned?: boolean;
    agent?: Agents;
    agentNoteType?: AgentNoteType;
    company?: Company;
    hierarchyPremier?: Agents;
    payoutLevel?: PayoutLevel;
    salesType?: SalesType;
    userNavigation?: Users;
    title?: string | undefined;
    tblDocumentMappings?: TblDocumentMapping[] | undefined;
}

export interface DepartmentOfInsuranceLicense {
    id?: number;
    agentId?: number;
    stateId?: number;
    issueDate?: Date | undefined;
    expirationDate?: Date | undefined;
    stateLicense?: string | undefined;
    residencyStatusId?: number | undefined;
    renewalDate?: Date | undefined;
    stateLicenseStatusId?: number | undefined;
    stateLicenseActionStatusId?: number | undefined;
    notes?: string | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    notificationSentDate?: Date | undefined;
    notificationEmailAddress?: string | undefined;
    tblDocumentMappings?: TblDocumentMapping[] | undefined;
}

export interface InsuredNote {
    id?: number;
    customerId?: number;
    note?: string | undefined;
    title?: string | undefined;
    createdDate?: Date;
    createdBy?: number;
    modifiedDate?: Date | undefined;
    modifiedBy?: number | undefined;
    private?: boolean;
    pinned?: boolean | undefined;
    deleted?: boolean | undefined;
    customer?: Customer;
    createdByNavigation?: Users;
    modifiedByNavigation?: Users;
    documentMappings?: TblDocumentMapping[] | undefined;
}

export interface TblDocumentMapping {
    id?: number;
    taskId?: number | undefined;
    noteId?: number | undefined;
    stateLicenseId?: number | undefined;
    documentId?: number | undefined;
    agentId?: number | undefined;
    insuredNoteId?: number | undefined;
    note?: AgentNotes;
    stateLicense?: DepartmentOfInsuranceLicense;
    task?: Tasks;
    document?: TblDocument;
    agents?: Agents;
    insuredNote?: InsuredNote;
}

export interface Tasks {
    id?: number;
    userId?: number;
    agentId?: number | undefined;
    customerId?: number | undefined;
    orderId?: number | undefined;
    taskDate?: Date | undefined;
    task?: string | undefined;
    description?: string | undefined;
    complete?: boolean;
    createdByUserId?: number;
    priority?: number | undefined;
    dateCreated?: Date;
    companyId?: number | undefined;
    dateCompleted?: Date | undefined;
    policyId?: number | undefined;
    completedByUserId?: number | undefined;
    modifyDate?: Date | undefined;
    modifiedBy?: number | undefined;
    company?: Company;
    policy?: Policy;
    tblDocumentMappings?: TblDocumentMapping[] | undefined;
    user?: Users;
    customer?: Customer;
    agent?: Agents;
}

export interface Policy {
    id?: number;
    customerId?: number;
    statusId?: number;
    profileId?: number;
    mgrId?: number | undefined;
    customerAge?: number;
    premium?: number;
    cashWithApp?: number;
    mode?: number;
    commission?: number | undefined;
    pcp?: string | undefined;
    annualPremium?: number;
    dateEffective?: Date;
    datePosted?: Date | undefined;
    dateEntered?: Date;
    dateSold?: Date;
    policyFee?: number | undefined;
    agentFee?: number | undefined;
    deductible?: number;
    replaced?: boolean;
    replacedDate?: Date | undefined;
    groupName?: string | undefined;
    pendingInfo?: string | undefined;
    targetPremium?: number;
    excessPremium?: number;
    deathBenefit?: number;
    saveAge?: boolean;
    tobacco?: boolean;
    ratingId?: number | undefined;
    singleLifePremium?: number | undefined;
    advanceMonths?: number;
    dateSurrender?: Date | undefined;
    overridePercent?: number;
    dateCreated?: Date;
    commissionTypeId?: number;
    confirmationNumber?: string | undefined;
    hybridRiderId?: number | undefined;
    policyNo?: string | undefined;
    faxed?: boolean;
    ftp?: boolean;
    uploadFileName?: string | undefined;
    createdByUserId?: number;
    pendingRequirements?: boolean;
    renewalReminderNote?: string | undefined;
    faxNumberSentTo?: string | undefined;
    surrenderPeriodYears?: number;
    memberCount?: number | undefined;
    submittedOnline?: boolean;
    locationPremierId?: number | undefined;
    ssbocreditCard?: boolean;
    appliedRatingId?: number | undefined;
    approvedRatingId?: number | undefined;
    isCopy?: boolean;
    licenseNumberId?: number | undefined;
    timestamp?: string | undefined;
    originalDateEffective?: Date;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    appliedRating?: PolicyRating;
    approvedRating?: PolicyRating;
    createdByUser?: Users;
    customer?: Customer;
    locationPremier?: Agents;
    modeNavigation?: Modes;
    profile?: Profile;
    status?: PolicyStatus;
    policyNumbers?: PolicyNumbers[] | undefined;
    tblDocument?: TblDocument[] | undefined;
    policyAnnuity?: PolicyAnnuity[] | undefined;
    policyExcess?: PolicyExcess[] | undefined;
    policyNote?: PolicyNote[] | undefined;
    policySingleLife?: PolicySingleLife[] | undefined;
    renewal?: Renewal[] | undefined;
    renewalCommissions?: RenewalCommissions[] | undefined;
    tasks?: Tasks[] | undefined;
}

export interface Profile {
    id?: number;
    commPlanId?: number;
    payToId?: number;
    mgrId?: number | undefined;
    levelId?: number;
    status?: string | undefined;
    comments?: string | undefined;
    paymentSourceId?: number;
    dateCreated?: Date;
    isActive?: boolean;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    commPlan?: CommPlan;
    level?: TblLevel;
    payTo?: Agents;
    paymentSource?: TblPaymentSource;
    policy?: Policy[] | undefined;
}

export interface TblLevel {
    id?: number;
    productId?: number;
    agencyId?: number | undefined;
    licenseId?: number;
    level?: number | undefined;
    specialInstructions?: string | undefined;
    payoutLevelId?: number | undefined;
    payoutLevelDetailId?: number | undefined;
    privateInstructions?: boolean | undefined;
    dateCreated?: Date | undefined;
    sortOrder?: number | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    license?: License;
    product?: TblProduct;
    tblLevelMarketer?: TblLevelMarketer[] | undefined;
    profile?: Profile[] | undefined;
}

export interface TblProduct {
    id?: number;
    prodNum?: string | undefined;
    companyId?: number;
    product?: string | undefined;
    typeId?: number;
    age1?: number;
    level1?: number;
    age2?: number;
    level2?: number;
    age3?: number;
    level3?: number;
    age4?: number;
    level4?: number;
    age5?: number;
    level5?: number;
    age6?: number;
    level6?: number;
    age7?: number;
    level7?: number;
    age8?: number;
    level8?: number;
    age9?: number;
    level9?: number;
    age10?: number;
    level10?: number;
    policyFee?: number;
    agentFee?: number;
    rider?: boolean;
    tripCategoryId?: number;
    hidden?: boolean;
    subCategory?: string | undefined;
    payoutLevelId?: number | undefined;
    productTypeId?: number;
    productCategoryId?: number;
    defaultPremium?: number;
    defaultMode?: number;
    importDefaultPremium?: number;
    importDefaultMode?: number;
    subCategoryId?: number;
    carrierProductName?: string | undefined;
    fraudWatch?: boolean;
    divisionId?: number;
    dateCreated?: Date;
    checkForCertification?: boolean;
    checkForAppointment?: boolean;
    productClassId?: number | undefined;
    productCode?: string | undefined;
    isAppointmentAndCertificationRequired?: boolean;
    isShowPremiumInCommissionReportStatement?: boolean;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    subCategoryNavigation?: TblProductSubCategory;
    submissionAutoUncheckRulesetFilterProduct?: SubmissionAutoUncheckRulesetFilterProduct[] | undefined;
    submissionRequirementRulesetFilterProduct?: SubmissionRequirementRulesetFilterProduct[] | undefined;
    submissionRulesetFilterProduct?: SubmissionRulesetFilterProduct[] | undefined;
    certification?: Certification[] | undefined;
    tblDocument?: TblDocument[] | undefined;
    tblLevel?: TblLevel[] | undefined;
}

export interface SubmissionRequirementRulesetFilterProduct {
    submissionRequirementRulesetFilterProductId?: number;
    submissionRequirementRulesetId?: number;
    productId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    product?: TblProduct;
    submissionRequirementRuleset?: SubmissionRequirementRuleset;
}

export interface SubmissionRequirementRuleset {
    submissionRequirementRulesetId?: number;
    submissionRequirementRulesetName?: string | undefined;
    submissionRulesetType?: number;
    dateTimeCreated?: Date;
    dateTimeModified?: Date | undefined;
    createdByUserId?: number;
    modifiedByUserId?: number | undefined;
    createdByUser?: Users;
    modifiedByUser?: Users;
    submissionRequirementRulesetFilterCompany?: SubmissionRequirementRulesetFilterCompany[] | undefined;
    submissionRequirementRulesetFilterDocumentType?: SubmissionRequirementRulesetFilterDocumentType[] | undefined;
    submissionRequirementRulesetFilterPolicyEffectiveDateYear?: SubmissionRequirementRulesetFilterPolicyEffectiveDateYear[] | undefined;
    submissionRequirementRulesetFilterProduct?: SubmissionRequirementRulesetFilterProduct[] | undefined;
    submissionRequirementRulesetFilterProductSubcategory?: SubmissionRequirementRulesetFilterProductSubcategory[] | undefined;
    submissionRequirementRulesetFilterState?: SubmissionRequirementRulesetFilterState[] | undefined;
}

export interface SubmissionRequirementRulesetFilterDocumentType {
    submissionRequirementRulesetFilterDocumentTypeId?: number;
    submissionRequirementRulesetId?: number;
    documentTypeId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    documentType?: FileType;
    submissionRequirementRuleset?: SubmissionRequirementRuleset;
}

export interface FileType {
    id?: number;
    type?: string | undefined;
    isHierarchyRequired?: boolean;
    isInsured?: boolean;
    submissionAutoUncheckRulesetFilterDocumentType?: SubmissionAutoUncheckRulesetFilterDocumentType[] | undefined;
    submissionRequirementRulesetFilterDocumentType?: SubmissionRequirementRulesetFilterDocumentType[] | undefined;
    submissionRulesetFilterDocumentType?: SubmissionRulesetFilterDocumentType[] | undefined;
    tblDocument?: TblDocument[] | undefined;
}

export interface SubmissionAutoUncheckRulesetFilterDocumentType {
    submissionAutoUncheckRulesetFilterDocumentTypeId?: number;
    submissionAutoUncheckRulesetId?: number;
    documentTypeId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    documentType?: FileType;
    submissionAutoUncheckRuleset?: SubmissionAutoUncheckRuleset;
}

export interface SubmissionAutoUncheckRulesetFilterPolicyEffectiveDateYear {
    submissionAutoUncheckRulesetFilterPolicyEffectiveDateYearId?: number;
    submissionAutoUncheckRulesetId?: number;
    policyEffectiveDateYear?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    submissionAutoUncheckRuleset?: SubmissionAutoUncheckRuleset;
}

export interface SubmissionAutoUncheckRuleset {
    submissionAutoUncheckRulesetId?: number;
    submissionAutoUncheckRulesetName?: string | undefined;
    submissionRulesetType?: number;
    dateTimeCreated?: Date;
    dateTimeModified?: Date | undefined;
    createdByUserId?: number;
    modifiedByUserId?: number | undefined;
    createdByUser?: Users;
    modifiedByUser?: Users;
    submissionAutoUncheckRulesetFilterCompany?: SubmissionAutoUncheckRulesetFilterCompany[] | undefined;
    submissionAutoUncheckRulesetFilterDocumentType?: SubmissionAutoUncheckRulesetFilterDocumentType[] | undefined;
    submissionAutoUncheckRulesetFilterPolicyEffectiveDateYear?: SubmissionAutoUncheckRulesetFilterPolicyEffectiveDateYear[] | undefined;
    submissionAutoUncheckRulesetFilterProduct?: SubmissionAutoUncheckRulesetFilterProduct[] | undefined;
    submissionAutoUncheckRulesetFilterProductSubcategory?: SubmissionAutoUncheckRulesetFilterProductSubcategory[] | undefined;
    submissionAutoUncheckRulesetFilterState?: SubmissionAutoUncheckRulesetFilterState[] | undefined;
}

export interface SubmissionAutoUncheckRulesetFilterCompany {
    submissionAutoUncheckRulesetFilterCompanyId?: number;
    submissionAutoUncheckRulesetId?: number;
    companyId?: number;
    dateTimeCreated?: Date;
    createdByUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    company?: Company;
    createdByUser?: Users;
    submissionAutoUncheckRuleset?: SubmissionAutoUncheckRuleset;
}

export interface Appointment {
    id?: number;
    agentId?: number;
    companyId?: number;
    effectiveDate?: Date;
    state?: string | undefined;
    appointmentNote?: string | undefined;
    recordStatus?: boolean | undefined;
    newRecord?: boolean | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    company?: Company;
}

export interface EmailType {
    id?: number;
    type?: string | undefined;
    companyContact?: CompanyContact[] | undefined;
    agentContact?: AgentContact[] | undefined;
    insuredContact?: InsuredContact[] | undefined;
}

export interface InsuredContact {
    id?: number;
    insuredId?: number;
    contactTypeId?: number;
    contactValue?: string | undefined;
    description?: string | undefined;
    createdByUserId?: number;
    dateCreated?: Date;
    default?: boolean;
    enableSMS?: boolean;
    phoneTypeId?: number | undefined;
    emailTypeId?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    insured?: Customer;
    contactType?: ContactType;
    phoneType?: PhoneType;
    createdByUser?: Users;
    emailType?: EmailType;
}

export interface PhoneType {
    id?: number;
    phoneTypeName?: string | undefined;
    sortOrder?: number;
    agentContact?: AgentContact[] | undefined;
    insuredContact?: InsuredContact[] | undefined;
    companyContact?: CompanyContact[] | undefined;
}

export interface AlternativePointOfContactType {
    id?: number;
    type?: string | undefined;
    companyContact?: CompanyContact[] | undefined;
    agentContact?: AgentContact[] | undefined;
}

export interface AgentContact {
    id?: number;
    agentId?: number;
    contactTypeId?: number;
    contactValue?: string | undefined;
    description?: string | undefined;
    createdByUserId?: number;
    dateCreated?: Date;
    default?: boolean;
    enableSMS?: boolean;
    phoneTypeId?: number | undefined;
    emailTypeId?: number | undefined;
    alternativePointOfContactTypeId?: number | undefined;
    isPhoneUnsubscribed?: boolean | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    contactType?: ContactType;
    phoneType?: PhoneType;
    createdByUser?: Users;
    alternativePointOfContactType?: AlternativePointOfContactType;
    emailType?: EmailType;
}

export interface ContactType {
    id?: number;
    contactTypeName?: string | undefined;
    isHidden?: boolean;
    isHiddenForInsured?: boolean;
    agentContact?: AgentContact[] | undefined;
    insuredContact?: InsuredContact[] | undefined;
    companyContact?: CompanyContact[] | undefined;
}

export interface CompanyContact {
    id?: number;
    companyId?: number;
    contactTypeId?: number;
    contactValue?: string | undefined;
    notes?: string | undefined;
    createdByUserId?: number;
    dateCreated?: Date;
    phoneTypeId?: number | undefined;
    emailTypeId?: number | undefined;
    alternativePointOfContactTypeId?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    company?: Company;
    contactType?: ContactType;
    createdByUser?: Users;
    emailType?: EmailType;
    phoneType?: PhoneType;
    alternativePointOfContactType?: AlternativePointOfContactType;
}

export interface CompanyNote {
    id?: number;
    companyId?: number;
    title?: string | undefined;
    note?: string | undefined;
    createdDate?: Date;
    createdBy?: number;
    modifiedDate?: Date | undefined;
    modifiedBy?: number | undefined;
    company?: Company;
    createdByNavigation?: Users;
    modifiedByNavigation?: Users;
}

export interface Company {
    id?: number;
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    url?: string | undefined;
    email?: string | undefined;
    networkShare?: string | undefined;
    createDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    createdBy?: number | undefined;
    modifiedBy?: number | undefined;
    createdByUser?: Users;
    modifiedByUser?: Users;
    defaultPaymentSourceId?: number | undefined;
    abbreviation?: string | undefined;
    marketerRenewalSpecialProcessing?: boolean;
    proRateFirstYearCommissions?: boolean;
    hidden?: boolean;
    commissionProcessingDivisionId?: number;
    isSourceOfTruth?: boolean | undefined;
    isExportable?: boolean;
    carrierShortName?: string | undefined;
    premierLegalEntityLicenseId?: number | undefined;
    carrierGroupName?: string | undefined;
    isArchived?: boolean;
    premierLegalEntityAgentId?: number | undefined;
    canArrangementDifferByState?: boolean;
    canArrangementDifferByProductType?: boolean;
    canMarketerDifferByProductType?: boolean;
    canSendContractArrangementMarketer?: boolean;
    canSendCrossReference?: boolean;
    canSendPolicyLevelRate?: boolean;
    canVerifyDataIntegrity?: boolean;
    canArrangementReportToShareSameCompanyRole?: boolean;
    releaseGroupName?: string | undefined;
    plrandNewBusinessSeparationDate?: Date | undefined;
    isEligiblityRequired?: boolean;
    allowOverlappingDates?: boolean | undefined;
    carrierGroupId?: number | undefined;
    rigidContracting?: boolean;
    masterCarrierId?: string;
    agentDebt?: AgentDebt[] | undefined;
    licensePersistencyType?: LicensePersistencyType[] | undefined;
    submissionAutoUncheckRulesetFilterCompany?: SubmissionAutoUncheckRulesetFilterCompany[] | undefined;
    submissionRequirementRulesetFilterCompany?: SubmissionRequirementRulesetFilterCompany[] | undefined;
    submissionRulesetFilterCompany?: SubmissionRulesetFilterCompany[] | undefined;
    agentNotes?: AgentNotes[] | undefined;
    appointment?: Appointment[] | undefined;
    tblDocument?: TblDocument[] | undefined;
    license?: License[] | undefined;
    tasks?: Tasks[] | undefined;
    companyContact?: CompanyContact[] | undefined;
    companyAddresses?: CompanyAddresses[] | undefined;
    companyNotes?: CompanyNote[] | undefined;
}

export interface LicenseAdvanceOption {
    licenseAdvanceOptionId?: number;
    licenseAdvanceOptionName?: string | undefined;
    license?: License[] | undefined;
}

export interface LicenseStatusReason {
    id?: number;
    reason?: string | undefined;
    statusId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    status?: LicenseStatus;
    license?: License[] | undefined;
}

export interface LicenseStatus {
    id?: number;
    status?: string | undefined;
    isActiveStatus?: boolean;
    licenseStatusReason?: LicenseStatusReason[] | undefined;
    license?: License[] | undefined;
}

export interface LicensePrincipalAgents {
    id?: number;
    licenseId?: number;
    principalAgentId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    license?: License;
    principalAgent?: Agents;
}

export interface CompanyLicenseNumberDefaults {
    id?: number;
    companyId?: number;
    licenseNumberTypeId?: number;
    isWritableDefault?: boolean;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    licenseNumberType?: LicenseNumberType;
}

export interface LicenseNumberType {
    id?: number;
    licenseNumberTypeName?: string | undefined;
    companyLicenseNumberDefaults?: CompanyLicenseNumberDefaults[] | undefined;
    licenseNumber?: LicenseNumber[] | undefined;
}

export interface LicenseNumber {
    id?: number;
    licenseId?: number;
    number?: string | undefined;
    licenseNumberTypeId?: number;
    isWritable?: boolean;
    crossReferenceId?: number | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    license?: License;
    licenseNumberType?: LicenseNumberType;
}

export interface LicenseAdvanced {
    id?: number;
    advanced?: string | undefined;
    sortOrder?: number;
    license?: License[] | undefined;
}

export interface LicenseAppointmentType {
    id?: number;
    type?: string | undefined;
    license?: License[] | undefined;
}

export interface LicenseNotes {
    id?: number;
    licenseId?: number;
    note?: string | undefined;
    createdDate?: Date;
    createdBy?: number;
    modifiedDate?: Date | undefined;
    modifiedBy?: number | undefined;
    license?: License;
    createdByNavigation?: Users;
    modifiedByNavigation?: Users;
}

export interface LicenseCommunication {
    id?: number;
    createdDate?: Date;
    createdByUserId?: number;
    agentContactId?: number | undefined;
    communicationTypeId?: number;
    licenseId?: number;
    inheratance?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agentContact?: AgentContact;
    license?: License;
}

export interface LicenseLocation {
    id?: number;
    licenseId?: number;
    locationId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    location?: Agents;
}

export interface License {
    id?: number;
    agentId?: number;
    companyId?: number;
    statusId?: number;
    apptDate?: Date;
    termDate?: Date | undefined;
    submittedDate?: Date | undefined;
    agentNumber?: string | undefined;
    agencyNumber?: string | undefined;
    notes?: string | undefined;
    compNumber?: string | undefined;
    dateCreated?: Date;
    reportsToAgentId?: number;
    reportsToLicenseId?: number | undefined;
    userId?: number;
    underConstruction?: boolean | undefined;
    doNotCall?: boolean;
    doNotCallDownlineDefault?: boolean;
    doNotEmail?: boolean;
    doNotEmailDownlineDefault?: boolean;
    doNotMarket?: boolean;
    doNotMarketDownlineDefault?: boolean;
    colorDownlineWhenImporting?: number | undefined;
    bankAccountId?: number | undefined;
    agencyIsPayee?: boolean;
    timestamp?: string | undefined;
    payeeId?: number | undefined;
    statusReasonId?: number | undefined;
    statusReasonUpdatedDate?: Date;
    licenseAdvanceOptionId?: number | undefined;
    maxAdvanceAmount?: number;
    salesTypeId?: number;
    licenseAdvancedId?: number | undefined;
    processedBy?: number | undefined;
    contractReceiptDate?: Date | undefined;
    approvalDate?: Date | undefined;
    appSubmittedWithin90Days?: Date | undefined;
    appointmentType?: number | undefined;
    agentGroupId?: number | undefined;
    onlyShowActiveAndPending?: boolean | undefined;
    replacedFromLicenseId?: number | undefined;
    replacedByLicenseId?: number | undefined;
    advance_Months?: number;
    createdBy?: number | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    bankAccount?: BankAccounts;
    company?: Company;
    licenseAdvanceOption?: LicenseAdvanceOption;
    payee?: Agents;
    salesType?: SalesType;
    status?: LicenseStatus;
    statusReason?: LicenseStatusReason;
    user?: Users;
    licensePersistency?: LicensePersistency[] | undefined;
    licensePrincipalAgents?: LicensePrincipalAgents[] | undefined;
    tblLevel?: TblLevel[] | undefined;
    licenseNumber?: LicenseNumber[] | undefined;
    licenseStates?: LicenseStates[] | undefined;
    licenseAdvanced?: LicenseAdvanced;
    users?: Users;
    licenseAppointmentType?: LicenseAppointmentType;
    licenseNotes?: LicenseNotes[] | undefined;
    licenseCommunications?: LicenseCommunication[] | undefined;
    licenseLocations?: LicenseLocation[] | undefined;
}

export interface BankAccounts {
    bankAccountId?: number;
    agentId?: number;
    bankId?: number | undefined;
    accountNumber?: string | undefined;
    description?: string | undefined;
    createdByUserId?: number;
    dateCreated?: Date;
    bankAccountTypeId?: number | undefined;
    bankAccountPaymentMethodId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    bank?: Bank;
    bankAccountPaymentMethod?: BankAccountPaymentMethod;
    bankAccountType?: BankAccountType;
    createdByUser?: Users;
    license?: License[] | undefined;
}

export interface PayoutLevelDetails {
    id?: number;
    payoutLevelId?: number;
    productId?: number;
    description?: string | undefined;
    commission?: number;
    dateCreated?: Date;
    createUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    createUser?: Users;
}

export interface TblDocumentWorkflowStatus {
    id?: number;
    workflowStatus?: string | undefined;
    path?: string | undefined;
    displayInWorkflowKpis?: boolean | undefined;
    tblDocument?: TblDocument[] | undefined;
    workflowProcessLog?: WorkflowProcessLog[] | undefined;
}

export interface WorkflowProcessLog {
    id?: number;
    masterDocId?: number;
    workflowStatusId?: number;
    userId?: number;
    dateTimeOfAction?: Date;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    masterDoc?: TblDocument;
    user?: Users;
    workflowStatus?: TblDocumentWorkflowStatus;
}

export interface AgentAlert {
    id?: number;
    alert?: string | undefined;
    agentId?: number;
    createdBy?: number;
    createdDate?: Date;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    agent?: Agents;
    createdByNavigation?: Users;
    modifiedByNavigation?: Users;
}

export interface ProviderUser {
    providerUserId?: number;
    identityUserId?: string | undefined;
    provider?: string | undefined;
    userId?: number;
    user?: Users;
}

export interface FederalTaxClassification {
    id?: number;
    classification?: string | undefined;
    taxpayerIdentification?: TaxpayerIdentification[] | undefined;
}

export interface TaxpayerIdentification {
    taxpayerId?: number;
    name?: string | undefined;
    businessName?: string | undefined;
    ein?: string | undefined;
    ssn?: string | undefined;
    addressId?: number;
    federalTaxClassificationId?: number;
    modifiedBy?: number | undefined;
    modifiedDate?: Date | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    federalTaxClassification?: FederalTaxClassification;
    modifiedByNavigation?: Users;
    agents?: Agents[] | undefined;
}

export interface Users {
    id?: number;
    loginName?: string | undefined;
    first?: string | undefined;
    last?: string | undefined;
    secLevel?: number;
    password?: string | undefined;
    email?: string | undefined;
    userId?: number | undefined;
    extension?: number | undefined;
    teamId?: number;
    marketerId?: number | undefined;
    active?: boolean | undefined;
    newSystemOnly?: boolean | undefined;
    agencyId?: string | undefined;
    workflowEmail?: boolean;
    workflowTasks?: boolean;
    hostedEmailPassword?: string | undefined;
    ciscoUserName?: string | undefined;
    ciscoPassword?: string | undefined;
    domainName?: string | undefined;
    phoneType?: number;
    maxLeadCount?: number;
    clearBrowserCache?: boolean;
    impersonatedUserId?: number | undefined;
    managingTeamId?: number | undefined;
    phoneDeviceId?: string | undefined;
    dateCreated?: Date;
    leadCallListId?: number | undefined;
    adguid?: string | undefined;
    isAdsyncable?: boolean | undefined;
    userProperties?: string | undefined;
    contractGridColProperties?: string | undefined;
    isDownlineAgency?: boolean;
    downlineAgencyId?: number | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    leadCallList?: Calllist;
    marketer?: Agents;
    bankAccounts?: BankAccounts[] | undefined;
    policyNumbers?: PolicyNumbers[] | undefined;
    submissionAutoUncheckRulesetCreatedByUser?: SubmissionAutoUncheckRuleset[] | undefined;
    submissionAutoUncheckRulesetFilterCompany?: SubmissionAutoUncheckRulesetFilterCompany[] | undefined;
    submissionAutoUncheckRulesetFilterDocumentType?: SubmissionAutoUncheckRulesetFilterDocumentType[] | undefined;
    submissionAutoUncheckRulesetFilterPolicyEffectiveDateYear?: SubmissionAutoUncheckRulesetFilterPolicyEffectiveDateYear[] | undefined;
    submissionAutoUncheckRulesetFilterProduct?: SubmissionAutoUncheckRulesetFilterProduct[] | undefined;
    submissionAutoUncheckRulesetFilterProductSubcategory?: SubmissionAutoUncheckRulesetFilterProductSubcategory[] | undefined;
    submissionAutoUncheckRulesetFilterState?: SubmissionAutoUncheckRulesetFilterState[] | undefined;
    submissionAutoUncheckRulesetModifiedByUser?: SubmissionAutoUncheckRuleset[] | undefined;
    submissionRequirementRulesetCreatedByUser?: SubmissionRequirementRuleset[] | undefined;
    submissionRequirementRulesetFilterCompany?: SubmissionRequirementRulesetFilterCompany[] | undefined;
    submissionRequirementRulesetFilterDocumentType?: SubmissionRequirementRulesetFilterDocumentType[] | undefined;
    submissionRequirementRulesetFilterPolicyEffectiveDateYear?: SubmissionRequirementRulesetFilterPolicyEffectiveDateYear[] | undefined;
    submissionRequirementRulesetFilterProduct?: SubmissionRequirementRulesetFilterProduct[] | undefined;
    submissionRequirementRulesetFilterProductSubcategory?: SubmissionRequirementRulesetFilterProductSubcategory[] | undefined;
    submissionRequirementRulesetFilterState?: SubmissionRequirementRulesetFilterState[] | undefined;
    submissionRequirementRulesetModifiedByUser?: SubmissionRequirementRuleset[] | undefined;
    submissionRulesetConnectorTypeEmailCreatedByUser?: SubmissionRulesetConnectorTypeEmail[] | undefined;
    submissionRulesetConnectorTypeEmailModifiedByUser?: SubmissionRulesetConnectorTypeEmail[] | undefined;
    submissionRulesetConnectorTypeFtpCreatedByUser?: SubmissionRulesetConnectorTypeFtp[] | undefined;
    submissionRulesetConnectorTypeFtpModifiedByUser?: SubmissionRulesetConnectorTypeFtp[] | undefined;
    submissionRulesetCreatedByUser?: SubmissionRuleset[] | undefined;
    submissionRulesetFilterCompany?: SubmissionRulesetFilterCompany[] | undefined;
    submissionRulesetFilterDocumentType?: SubmissionRulesetFilterDocumentType[] | undefined;
    submissionRulesetFilterPolicyEffectiveDateYear?: SubmissionRulesetFilterPolicyEffectiveDateYear[] | undefined;
    submissionRulesetFilterProduct?: SubmissionRulesetFilterProduct[] | undefined;
    submissionRulesetFilterProductSubcategory?: SubmissionRulesetFilterProductSubcategory[] | undefined;
    submissionRulesetFilterState?: SubmissionRulesetFilterState[] | undefined;
    submissionRulesetModifiedByUser?: SubmissionRuleset[] | undefined;
    submissionSenderTypeEmailCreatedByUser?: SubmissionSenderTypeEmail[] | undefined;
    submissionSenderTypeEmailModifiedByUser?: SubmissionSenderTypeEmail[] | undefined;
    submissionTypeEmailCreatedByUser?: SubmissionTypeEmail[] | undefined;
    submissionTypeEmailModifiedByUser?: SubmissionTypeEmail[] | undefined;
    submissionTypeFtpCreatedByUser?: SubmissionTypeFtp[] | undefined;
    submissionTypeFtpModifiedByUser?: SubmissionTypeFtp[] | undefined;
    agentContact?: AgentContact[] | undefined;
    agentNotes?: AgentNotes[] | undefined;
    agentsCreatedByNavigation?: Agents[] | undefined;
    agentsProfileUpdatedByUser?: Agents[] | undefined;
    agentsUser?: Agents[] | undefined;
    certification?: Certification[] | undefined;
    commissionRunBatches?: CommissionRunBatches[] | undefined;
    license?: License[] | undefined;
    orders?: Orders[] | undefined;
    payoutLevel?: PayoutLevel[] | undefined;
    payoutLevelDetails?: PayoutLevelDetails[] | undefined;
    policy?: Policy[] | undefined;
    userManageTeam?: UserManageTeam[] | undefined;
    workflowProcessLog?: WorkflowProcessLog[] | undefined;
    licenseProcessedBy?: License[] | undefined;
    insuredContact?: InsuredContact[] | undefined;
    companyContact?: CompanyContact[] | undefined;
    companyCreateUsers?: Company[] | undefined;
    companyModifyUsers?: Company[] | undefined;
    companyAddresses?: CompanyAddresses[] | undefined;
    companyNoteCreatedByNavigations?: CompanyNote[] | undefined;
    companyNoteModifiedByNavigations?: CompanyNote[] | undefined;
    agentAlertCreatedByNavigations?: AgentAlert[] | undefined;
    agentAlertModifiedByNavigations?: AgentAlert[] | undefined;
    providerUser?: ProviderUser;
    taxpayerIdentification?: TaxpayerIdentification[] | undefined;
    insuredNoteCreatedByNavigations?: InsuredNote[] | undefined;
    insuredNoteModifiedByNavigations?: InsuredNote[] | undefined;
    licenseNoteCreatedByNavigations?: LicenseNotes[] | undefined;
    licenseNoteModifiedByNavigations?: LicenseNotes[] | undefined;
}

export interface AgentHierarchyLevel {
    id?: number;
    name?: string | undefined;
    agents?: Agents[] | undefined;
}

export interface TblStatus {
    id?: number;
    status?: string | undefined;
    message?: string | undefined;
    agents?: Agents[] | undefined;
}

export interface AgentLeadSource {
    agentLeadSourceId?: number;
    agentLeadSourceName?: string | undefined;
    leadMustBeReferrable?: boolean;
    agentLead?: AgentLead[] | undefined;
}

export interface AgentLeadMeta {
    agentLeadId?: number;
    leadName?: string | undefined;
    leadFirstName?: string | undefined;
    leadLastName?: string | undefined;
    alternativeContactName?: string | undefined;
    recruiterName?: string | undefined;
    businessUnit?: string | undefined;
    leadNpn?: string | undefined;
    leadSource?: string | undefined;
    leadSourceDetail?: string | undefined;
    unverifiedLeadEmails?: string | undefined;
    unverifiedLeadPhoneNumbers?: string | undefined;
    verifiedLeadEmails?: string | undefined;
    verifiedLeadPhoneNumbers?: string | undefined;
    targetCarrier?: string | undefined;
    leadNote?: string | undefined;
    invalidReferral?: boolean;
    productContracted?: string | undefined;
    recruiterEmail?: string | undefined;
    recruiterPhone?: string | undefined;
    isClosed?: boolean;
    isPreContracted?: boolean;
    isContractingSent?: boolean;
    isContracted?: boolean;
    hasPolicies?: boolean;
    productLineActivated?: boolean;
    sharepointId?: number | undefined;
    invalidForActivation?: boolean;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agentLead?: AgentLead;
}

export interface AgentLeadPhase {
    id?: number;
    leadPhaseName?: string | undefined;
}

export interface AgentLeadPhaseDetail {
    id?: number;
    leadPhaseId?: number;
    leadPhaseDetailName?: string | undefined;
    isLeadPhaseDefault?: boolean;
}

export interface AgentLead {
    agentLeadId?: number;
    productLineId?: number | undefined;
    agentId?: number | undefined;
    assigneeId?: number | undefined;
    assignerId?: number | undefined;
    carrierId?: number | undefined;
    leadPhaseId?: number;
    leadPhaseDetailId?: number;
    dateCreated?: Date;
    dateAssigned?: Date | undefined;
    agentLeadSourceId?: number;
    agentLeadSourceDetailId?: number | undefined;
    dateFollowUp?: Date | undefined;
    subAssigneeId?: number | undefined;
    createdUserId?: number;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    agentLeadSource?: AgentLeadSource;
    agentLeadMeta?: AgentLeadMeta;
    assignee?: Users;
    subAssignee?: Users;
    leadPhase?: AgentLeadPhase;
    productLine?: AgentProductLine;
    carrier?: Company;
    leadPhaseDetail?: AgentLeadPhaseDetail;
}

export interface AgentMarketers {
    agentMarketerId?: number;
    agentId?: number;
    marketerId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    marketer?: Agents;
}

export interface AgentPortalPassword {
    agentPortalPasswordId?: number;
    agentId?: number;
    password?: string | undefined;
    salt?: string | undefined;
    dateCreated?: Date;
    agent?: Agents;
}

export interface AgentPortalPasswordReset {
    agentPortalPasswordResetId?: number;
    agentId?: number;
    resetCode?: string | undefined;
    expiresDateTime?: Date;
    isUsed?: boolean;
    dateCreated?: Date;
    agent?: Agents;
}

export interface AgentPrincipalAgents {
    id?: number;
    agentId?: number;
    principalAgentId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    principalAgent?: Agents;
}

export interface AgentToPayee {
    id?: number;
    agentId?: number;
    payeeId?: number;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    payee?: Agents;
}

export interface RenewalRates {
    id?: number;
    agentId?: number;
    ageId?: number;
    payToId?: number;
    month1?: number;
    month2?: number;
    rate?: number;
    flatRate?: boolean;
    flatRateAmount?: number;
    payFromProfit?: number;
    payFromId?: number;
    hidePremiumAndRate?: boolean;
    hideAllExceptAmount?: boolean;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    payTo?: Agents;
}

export interface AppUserRole {
    id?: number;
    userRoleName?: string | undefined;
    isDownlineRole?: boolean;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    appUserRoleDownlineAgencies?: AppUserRoleDownlineAgency[] | undefined;
}

export interface AppUserRoleDownlineAgency {
    id?: number;
    appUserRoleId?: number;
    agencyId?: number;
    userId?: number | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agency?: Agents;
    appUserRole?: AppUserRole;
}

export interface Agents {
    id?: number;
    lastName?: string | undefined;
    middle?: string | undefined;
    firstName?: string | undefined;
    nickname?: string | undefined;
    suffix?: string | undefined;
    status?: number | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    state?: string | undefined;
    workPhone?: string | undefined;
    email?: string | undefined;
    source?: number;
    lhrId?: number | undefined;
    agency?: string | undefined;
    dob?: Date | undefined;
    ssn?: string | undefined;
    encryptedSsn?: string | undefined;
    tin?: string | undefined;
    spouse?: string | undefined;
    terminatedOption?: number | undefined;
    dba?: string | undefined;
    smrId?: number | undefined;
    ratingId?: number | undefined;
    marketer?: boolean;
    timestamp?: string | undefined;
    healthRating?: string | undefined;
    lifeRating?: string | undefined;
    annuityRating?: string | undefined;
    finalExpenseRating?: string | undefined;
    userId?: number | undefined;
    password?: string | undefined;
    healthRatingLocked?: boolean;
    ltcrating?: string | undefined;
    website?: string | undefined;
    dateCreated?: Date | undefined;
    createdBy?: number;
    designation?: string | undefined;
    enableLogin?: boolean;
    hasDebt?: boolean;
    profileUpdatedByUserId?: number | undefined;
    npn?: string | undefined;
    defaultAddressId?: number | undefined;
    residentialAddressId?: number | undefined;
    commissionStatementAddressId?: number | undefined;
    doNotCall?: boolean;
    doNotEmail?: boolean;
    isLocation?: boolean;
    debtLevelId?: number;
    doNotMarket?: boolean;
    gender?: string | undefined;
    excludeFromTrip?: boolean;
    onlyPobox?: boolean;
    alternateLastName?: string | undefined;
    isEmployee?: boolean | undefined;
    accountingSystemVendorId?: string | undefined;
    isAgency?: boolean;
    marketerClassificationId?: number | undefined;
    vueExportFileDateTime?: Date | undefined;
    isSyncableWithVue?: boolean;
    isHiddenAgentProfile?: boolean;
    profilePicture?: string | undefined;
    federallyFacilitatedMarketplaceUserId?: string | undefined;
    receivePaperStatement?: boolean;
    isIntegrityPlatformPartner?: boolean;
    eoParticipant?: boolean;
    eoParticipantExpirationDate?: Date | undefined;
    w9?: Date | undefined;
    sureLC?: boolean | undefined;
    vested?: boolean;
    parentId?: number | undefined;
    hierarchyLevelId?: number | undefined;
    taxpayerIdentificationId?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    niprStatus?: string | undefined;
    niprUpdatedDate?: Date | undefined;
    createdByNavigation?: Users;
    hierarchyLevel?: AgentHierarchyLevel;
    profileUpdatedByUser?: Users;
    statusNavigation?: TblStatus;
    user?: Users;
    agentDebt?: AgentDebt[] | undefined;
    agentLead?: AgentLead[] | undefined;
    agentMarketersAgent?: AgentMarketers[] | undefined;
    agentMarketersMarketer?: AgentMarketers[] | undefined;
    agentPortalPassword?: AgentPortalPassword[] | undefined;
    agentPortalPasswordReset?: AgentPortalPasswordReset[] | undefined;
    agentPrincipalAgentsAgent?: AgentPrincipalAgents[] | undefined;
    agentPrincipalAgentsPrincipalAgent?: AgentPrincipalAgents[] | undefined;
    agentProductLine?: AgentProductLine[] | undefined;
    bankAccounts?: BankAccounts[] | undefined;
    licensePrincipalAgents?: LicensePrincipalAgents[] | undefined;
    agentContact?: AgentContact[] | undefined;
    agentNotesAgent?: AgentNotes[] | undefined;
    agentNotesHierarchyPremier?: AgentNotes[] | undefined;
    agentToAddress?: AgentToAddress[] | undefined;
    agentToPayeeAgent?: AgentToPayee[] | undefined;
    agentToPayeePayee?: AgentToPayee[] | undefined;
    appointment?: Appointment[] | undefined;
    certification?: Certification[] | undefined;
    tblDocumentAgent?: TblDocument[] | undefined;
    tblDocumentMarketerAgent?: TblDocument[] | undefined;
    tblDocumentUplineAgent?: TblDocument[] | undefined;
    tblLevelMarketer?: TblLevelMarketer[] | undefined;
    licenseAgent?: License[] | undefined;
    licenseLocation?: LicenseLocation[] | undefined;
    licensePayee?: License[] | undefined;
    policy?: Policy[] | undefined;
    profile?: Profile[] | undefined;
    renewalCommissions?: RenewalCommissions[] | undefined;
    renewalRatesAgent?: RenewalRates[] | undefined;
    renewalRatesPayTo?: RenewalRates[] | undefined;
    userTeam?: UserTeam[] | undefined;
    userTeamAgencyId?: UserTeamAgencyId[] | undefined;
    users?: Users[] | undefined;
    agentAlert?: AgentAlert[] | undefined;
    appUserRoleDownlineAgencies?: AppUserRoleDownlineAgency[] | undefined;
    tblDocumentMappings?: TblDocumentMapping[] | undefined;
    taxpayerIdentification?: TaxpayerIdentification;
}

export interface TblDocument {
    id?: number;
    date?: Date | undefined;
    ssn?: string | undefined;
    path?: string | undefined;
    filename?: string | undefined;
    fileType?: number | undefined;
    notes?: string | undefined;
    committed?: boolean;
    lname?: string | undefined;
    fname?: string | undefined;
    policyNo?: string | undefined;
    volume?: string | undefined;
    agentId?: number | undefined;
    customerId?: number | undefined;
    paperport?: boolean;
    updated?: boolean;
    typeId?: number;
    companyId?: number | undefined;
    upload?: boolean | undefined;
    uploaded?: boolean;
    policyId?: number | undefined;
    licenseId?: number | undefined;
    createdBy?: number;
    createdDate?: Date;
    workflowStatusId?: number;
    assignedToUserId?: number | undefined;
    masterDocId?: number | undefined;
    ownerId?: number | undefined;
    appDate?: Date | undefined;
    private?: boolean;
    productId?: number | undefined;
    assignedToTeamId?: number | undefined;
    changeForm?: boolean;
    flag?: string | undefined;
    compressed?: boolean;
    file512Hash?: string | undefined;
    errorCount?: number;
    submissionReceived?: boolean;
    missingInfoComment?: string | undefined;
    guid?: string | undefined;
    synced?: boolean | undefined;
    insuredNumber?: string | undefined;
    agentCode?: string | undefined;
    pendingCertificates?: boolean | undefined;
    extension?: string | undefined;
    rowVersion?: string | undefined;
    uplineAgentId?: number | undefined;
    marketerAgentId?: number | undefined;
    submitToOption?: number | undefined;
    submitToValue?: string | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    agent?: Agents;
    assignedToTeam?: UserTeam;
    company?: Company;
    customer?: Customer;
    marketerAgent?: Agents;
    masterDoc?: TblDocument;
    policy?: Policy;
    product?: TblProduct;
    type?: FileType;
    uplineAgent?: Agents;
    workflowStatus?: TblDocumentWorkflowStatus;
    inverseMasterDoc?: TblDocument[] | undefined;
    workflowProcessLog?: WorkflowProcessLog[] | undefined;
    documentMapping?: TblDocumentMapping[] | undefined;
}

export interface Customer {
    id?: number;
    lname?: string | undefined;
    fname?: string | undefined;
    mi?: string | undefined;
    suffix?: string | undefined;
    street?: string | undefined;
    street2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    bday?: Date;
    ssn?: string | undefined;
    encryptedSsn?: string | undefined;
    weight?: number | undefined;
    gender?: string | undefined;
    height?: string | undefined;
    spouse?: string | undefined;
    status?: string | undefined;
    notes?: string | undefined;
    hicn?: string | undefined;
    dateCreated?: Date;
    tmpSsn?: string | undefined;
    isEmployee?: boolean;
    payorName?: string | undefined;
    insuredNumber?: string | undefined;
    vueExportFileDateTime?: Date | undefined;
    timestamp?: string | undefined;
    medicareBeneficiaryIdentificationNumber?: string | undefined;
    insuredId?: number | undefined;
    countyName?: string | undefined;
    medicaidNumber?: string | undefined;
    subsidyLevelId?: number | undefined;
    statePharmaceuticalProgramMemberNumber?: string | undefined;
    dayPhone?: string | undefined;
    createdBy?: number | undefined;
    dateModified?: Date | undefined;
    modifiedBy?: number | undefined;
    tblDocument?: TblDocument[] | undefined;
    policy?: Policy[] | undefined;
    insuredContact?: InsuredContact[] | undefined;
    subsidyLevel?: SubsidyLevel;
    insuredNote?: InsuredNote[] | undefined;
}

export interface SubsidyLevel {
    id?: number;
    value?: string | undefined;
    customer?: Customer[] | undefined;
}

export interface CustomerDetailModel {
    id?: number;
    lName?: string | undefined;
    fName?: string | undefined;
    mi?: string | undefined;
    suffix?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    bDay?: Date;
    ssn?: string | undefined;
    encryptedSSN?: string | undefined;
    hicn?: string | undefined;
    isEmployee?: boolean;
    payorName?: string | undefined;
    countyName?: string | undefined;
    notes?: string | undefined;
    medicareBeneficiaryIdentificationNumber?: string | undefined;
    street?: string | undefined;
    street2?: string | undefined;
    medicaidNumber?: string | undefined;
    subsidyLevelId?: number | undefined;
    statePharmaceuticalProgramMemberNumber?: string | undefined;
    gender?: string | undefined;
    statesList?: StateListItem[] | undefined;
    countyList?: AlternateCounty[] | undefined;
    subsidyLevelList?: SubsidyLevel[] | undefined;
}

export interface CustomerDetailByIdModel {
    id?: number;
    lName?: string | undefined;
    fName?: string | undefined;
    mi?: string | undefined;
    suffix?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    bDay?: Date;
    ssn?: string | undefined;
    hicn?: string | undefined;
    isEmployee?: boolean;
    payorName?: string | undefined;
    countyName?: string | undefined;
    notes?: string | undefined;
    medicareBeneficiaryIdentificationNumber?: string | undefined;
    street?: string | undefined;
    street2?: string | undefined;
    gender?: string | undefined;
    medicaidNumber?: string | undefined;
    statePharmaceuticalProgramMemberNumber?: string | undefined;
    subsidyLevel?: string | undefined;
    subsidyLevelId?: number | undefined;
}

export interface ValidateCustomerDetailsResponse {
    value?: string | undefined;
    valid?: boolean;
}

export interface MergeCustomerPreviewRequestModel {
    fromCustomerId: number;
    toCustomerId: number;
}

export interface MergeCustomerPreviewResponseModel {
    fromCustomerId?: number;
    toCustomerId?: number;
    fromAddress?: string | undefined;
    toAddress?: string | undefined;
    fromCityStateZip?: string | undefined;
    toCityStateZip?: string | undefined;
    fromHICN?: string | undefined;
    toHICN?: string | undefined;
    fromFullName?: string | undefined;
    toFullName?: string | undefined;
    fromPoliciesCount?: string | undefined;
    toPoliciesCount?: string | undefined;
    fromDocCount?: string | undefined;
    toDocCount?: string | undefined;
    message?: string | undefined;
    fromSSN?: string | undefined;
    fromMBI?: string | undefined;
    toSSN?: string | undefined;
    toMBI?: string | undefined;
}

export interface DocumentAttachment {
    mappingId?: number;
    documentId?: number;
    isDeleted?: boolean;
    documentName?: string | undefined;
    companyName?: string | undefined;
    fileType?: string | undefined;
}

export interface NoteModel {
    id?: number;
    insuredId?: number;
    title?: string | undefined;
    note?: string | undefined;
    createdDate?: Date;
    createdDateForView?: string | undefined;
    createdDateForGrid?: string | undefined;
    modifiedDateForView?: string | undefined;
    createdBy?: string | undefined;
    modifiedDate?: Date | undefined;
    modifiedBy?: string | undefined;
    private?: boolean;
    status?: string | undefined;
    fileName?: string | undefined;
    pinned?: boolean | undefined;
    deleted?: boolean | undefined;
    documentAttachments?: DocumentAttachment[] | undefined;
}

export interface NotesSearchResponse {
    recordCount?: number;
    data?: NoteModel[] | undefined;
}

export interface CreateUpdateNoteModel {
    id?: number;
    insuredId?: number;
    title?: string | undefined;
    note?: string | undefined;
    private?: boolean;
    documentAttachmentList?: DocumentAttachment[] | undefined;
}

export interface ExcessPremiumListModel {
    id?: number;
    policyId?: number;
    amount?: number;
    overRide?: number;
    date?: Date;
}

export interface ExcessPremiumModel {
    id?: number;
    policyId?: number;
    amount?: number;
    date?: Date;
    override?: number;
}

export interface CreateUpdateExcessPremiumModel {
    id?: number;
    policyId?: number;
    amount?: number;
    override?: number;
    date?: Date;
}

export interface AgentPolicyListModel {
    id?: number;
    insuredId?: number;
    policyNumber?: string | undefined;
    company?: string | undefined;
    companyId?: number;
    dateIssued?: Date;
    displayDateIssued?: Date;
    product?: string | undefined;
    insured?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    status?: string | undefined;
    statusId?: number;
    points?: number;
}

export interface AllPoliciesByAgentResponse {
    recordCount?: number;
    data?: AgentPolicyListModel[] | undefined;
}

export interface LicenseNumbers {
    id?: number;
    number?: string | undefined;
    isWritable?: boolean;
}

export interface LocationAgent {
    locationAgentId?: number;
    locationName?: string | undefined;
    dba?: string | undefined;
}

export interface PolicyByIdResponseModel {
    id?: number;
    agentId?: number;
    customer?: string | undefined;
    agent?: string | undefined;
    product?: string | undefined;
    licenseNumber?: string | undefined;
    advanceMonth?: number;
    company?: string | undefined;
    companyId?: number;
    plan?: string | undefined;
    marketer?: string | undefined;
    payTo?: string | undefined;
    productCategoryName?: string | undefined;
    cashWithApp?: number;
    premium?: number;
    mode?: string | undefined;
    pcp?: string | undefined;
    annualPremium?: number;
    dateSold?: Date;
    dateEffective?: Date;
    originalDateEffective?: Date | undefined;
    licenseId?: number;
    profileId?: number;
    productId?: number;
    productCategory?: string | undefined;
    modeId?: number;
    locationPremierId?: number;
    locationPremierAgent?: string | undefined;
    licenseNumbers?: LicenseNumbers[] | undefined;
    locationAgents?: LocationAgent[] | undefined;
    modes?: ListItem[] | undefined;
    commissionTypes?: ListItem[] | undefined;
    paymentTypes?: ListItem[] | undefined;
    appliedRatings?: ListItem[] | undefined;
    approvedRatings?: ListItem[] | undefined;
    statuses?: ListItem[] | undefined;
    noteTypes?: ListItem[] | undefined;
    replacedDate?: Date | undefined;
    statusId?: number;
    datePosted?: Date | undefined;
    dateEntered?: Date;
    dateSurrender?: Date | undefined;
    pendingInfo?: string | undefined;
    status?: string | undefined;
    division?: string | undefined;
    policy?: string | undefined;
    saveAge?: boolean;
    issueAge?: number;
    targetPremium?: number;
    deathBenefit?: number;
    spLife?: number;
    commissionTypeId?: number;
    enrollmentNumber?: string | undefined;
    appliedRatingId?: number | undefined;
    approvedRatingId?: number | undefined;
    ssboCreditCard?: boolean;
    excessAmount?: number;
    annuityAmount?: number;
    approvedRating?: string | undefined;
    appliedRating?: string | undefined;
    commission?: number | undefined;
    commissionType?: string | undefined;
    customerAge?: string | undefined;
    customerId?: number;
    commissionReceivedAmount?: number | undefined;
}

export interface PoliciesByCustomerListModel {
    policyId?: number;
    policyNumbers?: string | undefined;
    policyEffectiveDate?: Date;
    productName?: string | undefined;
    companyName?: string | undefined;
    agentName?: string | undefined;
    agentId?: number;
    policyStatus?: string | undefined;
    isEmployee?: boolean;
}

export interface GetAllPoliciesByCustomerResponse {
    recordCount?: number;
    data?: PoliciesByCustomerListModel[] | undefined;
}

export interface LicenseNumbers2 {
    id?: number;
    number?: string | undefined;
    isWritable?: boolean;
}

export interface LocationAgent2 {
    locationAgentId?: number;
    locationName?: string | undefined;
    dba?: string | undefined;
}

export interface SummaryModel {
    id?: number;
    agentId?: number;
    customer?: string | undefined;
    agent?: string | undefined;
    product?: string | undefined;
    licenseNumber?: string | undefined;
    company?: string | undefined;
    plan?: string | undefined;
    marketer?: string | undefined;
    payTo?: string | undefined;
    productCategoryName?: string | undefined;
    cashWithApp?: number;
    premium?: number;
    mode?: string | undefined;
    annualPremium?: number;
    dateSold?: Date;
    dateEffective?: Date;
    originalDateEffective?: Date | undefined;
    licenseId?: number;
    profileId?: number;
    productId?: number;
    productCategory?: string | undefined;
    modeId?: number;
    customerId?: number | undefined;
    locationPremierId?: number;
    licenseNumbers?: LicenseNumbers2[] | undefined;
    locationAgents?: LocationAgent2[] | undefined;
    modes?: ListItem[] | undefined;
    commissionTypes?: ListItem[] | undefined;
    paymentTypes?: ListItem[] | undefined;
    appliedRatings?: ListItem[] | undefined;
    approvedRatings?: ListItem[] | undefined;
    statuses?: ListItem[] | undefined;
    noteTypes?: ListItem[] | undefined;
}

export interface PaymentPlanModel {
    id?: number;
    division?: string | undefined;
    policy?: string | undefined;
    saveAge?: boolean;
    issueAge?: number;
    targetPremium?: number;
    deathBenefit?: number;
    spLife?: number;
    commissionTypeId?: number;
    enrollmentNumber?: string | undefined;
    appliedRatingId?: number | undefined;
    approvedRatingId?: number | undefined;
    paymentTypeId?: number;
    ssboCreditCard?: boolean;
    excessAmount?: number;
    annuityAmount?: number;
    approvedRating?: string | undefined;
    appliedRating?: string | undefined;
    commission?: number | undefined;
    commissionType?: string | undefined;
    customerAge?: string | undefined;
    customerId?: number;
}

export interface StatusModel {
    id?: number;
    replacedDate?: Date | undefined;
    dateSold?: Date;
    originalDateEffective?: Date | undefined;
    statusId?: number;
    datePosted?: Date | undefined;
    dateEntered?: Date;
    dateSurrender?: Date | undefined;
    pendingInfo?: string | undefined;
    status?: string | undefined;
}

export interface PolicyNoteModel {
    id?: number;
    policyId?: number;
    note?: string | undefined;
    private?: boolean;
    policyNoteTypeId?: number;
    readonly user?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    noteDate?: Date;
    convertedNoteDate?: Date;
    revenueNote?: boolean | undefined;
}

export interface PolicyNoteResponseModel {
    recordCount?: number;
    data?: PolicyNoteModel[] | undefined;
}

export interface PolicyNoteByIdReponseModel {
    id?: number;
    policyId?: number;
    note?: string | undefined;
    private?: boolean;
    policyNoteTypeId?: number;
    user?: string | undefined;
    noteDate?: Date;
}

export interface AgentsSearchList {
    agentId?: number;
    companyId?: number;
    licenseNumberId?: number | undefined;
    agent?: string | undefined;
    agentNumber?: string | undefined;
    company?: string | undefined;
    licenseStatus?: string | undefined;
    location?: string | undefined;
    contractId?: number;
}

export interface AgentSearchResponse {
    recordCount?: number;
    data?: AgentsSearchList[] | undefined;
}

export interface PolicyNumberList {
    policyNumberId?: number;
    policyNumber?: string | undefined;
    user?: string | undefined;
    dateEntered?: Date;
    isValid?: boolean;
}

export enum FileType2 {
    _0 = 0,
    _1 = 1,
}

export interface ReportFile {
    title?: string | undefined;
    data?: string | undefined;
    contentType?: string | undefined;
    fileName?: string | undefined;
}

export interface CalculatedCommissionResponse {
    premium?: number;
}

export interface Agent {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export interface Carrier {
    id?: number;
    name?: string | undefined;
    abbreviation?: string | undefined;
}

export interface Insured {
    id?: number;
    fName?: string | undefined;
    lName?: string | undefined;
}

export interface ProductCategory {
    id?: number;
    productCategoryName?: string | undefined;
}

export interface Product {
    id?: number;
    prodNum?: string | undefined;
    category?: ProductCategory;
}

export interface Policy2 {
    id?: number;
    effectiveDate?: Date;
    policyNumber?: string | undefined;
    agent?: Agent;
    carrier?: Carrier;
    insured?: Insured;
    product?: Product;
}

export interface PolicySummaryByIdResponseModel {
    policy?: Policy2;
}

export interface PolicyNumberLookupModel {
    policyID?: number;
    policyNumber?: string | undefined;
    awNs?: string[] | undefined;
}

export interface PolicyNumberResponse {
    recordCount?: number;
    data?: PolicyNumberLookupModel[] | undefined;
}

export interface InsuredDetailsLookupModel {
    id?: number;
    name?: string | undefined;
    awNs?: string[] | undefined;
}

export interface InsuredDetailsResponse {
    recordCount?: number;
    data?: InsuredDetailsLookupModel[] | undefined;
}

export interface AnnuityPremiumModel2 {
    id?: number;
    amount?: number;
    initialDeposit?: boolean;
    date?: Date;
}

export interface SinglePremiumModel {
    id?: number;
    amount?: number;
    date?: Date;
}

export interface ExcessPremiumModel2 {
    id?: number;
    amount?: number;
    date?: Date;
}

export interface CommissionReceivedByPolicyListModel {
    id?: number;
    amount?: number;
    date?: Date;
    policyId?: number;
    isEdit?: boolean;
    isDelete?: boolean;
}

export interface CreateUpdatePolicyModel {
    id?: number;
    customerId?: number;
    profileId?: number;
    company?: string | undefined;
    mgrId?: number | undefined;
    locationPremierId?: number | undefined;
    cashWithApp?: number;
    premium?: number;
    mode?: number;
    annualPremium?: number;
    dateSold?: string | undefined;
    dateEffective?: string | undefined;
    originalDateEffective?: string | undefined;
    licenseNumberId?: number | undefined;
    replacedDate?: Date;
    statusId?: number;
    datePosted?: string | undefined;
    dateEntered?: string | undefined;
    dateSurrender?: string | undefined;
    pendingInfo?: string | undefined;
    division?: string | undefined;
    policyNumber?: string | undefined;
    group?: string | undefined;
    saveAge?: boolean;
    issueAge?: number;
    targetPremium?: number;
    deathBenefit?: number;
    spLife?: number;
    commissionTypeId?: number;
    enrollmentNumber?: string | undefined;
    appliedRatingId?: number | undefined;
    approvedRatingId?: number | undefined;
    ssboCreditCard?: boolean;
    excessAmount?: number;
    annuityAmount?: number;
    isCopy?: boolean;
    commission?: number;
    advanceMonths?: number;
    copyMarketer?: boolean;
    createFollowUpTask?: boolean;
    taskDate?: Date;
    note?: string | undefined;
    policyNoteTypeId?: number;
    pcp?: string | undefined;
    canBypassAppointment?: boolean;
    canBypassCertification?: boolean;
    annuityPremiumModelList?: AnnuityPremiumModel2[] | undefined;
    singlePremiumModelList?: SinglePremiumModel[] | undefined;
    excessPremiumModelList?: ExcessPremiumModel2[] | undefined;
    commissionReceivedByPolicyModel?: CommissionReceivedByPolicyListModel[] | undefined;
    customAttributes?: CustAttrToEntityModel[] | undefined;
}

export interface CreateUpdatePolicyResponse {
    policyId?: number;
    isSuccess?: boolean;
    validationMessage?: string | undefined;
    canBypassAppointment?: boolean;
    canBypassCertification?: boolean;
    isSaveButtonEnabled?: boolean;
}

export interface CreateUpdateSummaryModel {
    id?: number;
    customerId?: number;
    profileId?: number;
    company?: string | undefined;
    mgrId?: number | undefined;
    locationPremierId?: number | undefined;
    cashWithApp?: number;
    premium?: number;
    mode?: number;
    annualPremium?: number;
    dateSold?: string | undefined;
    dateEffective?: string | undefined;
    originalDateEffective?: string | undefined;
    createdByUserId?: number;
    licenseNumberId?: number | undefined;
}

export interface CreateUpdatePolicyNoteModel {
    id?: number;
    policyId?: number;
    note?: string | undefined;
    private?: boolean;
    policyNoteTypeId?: number;
    userId?: number;
    agentId?: number;
    licenseId?: number;
    createdByUserId?: number;
    noteDate?: Date;
    copyDesignatedLicenseCommunication?: boolean;
    copyMarketer?: boolean;
    createFollowUpTask?: boolean;
    taskDate?: Date;
}

export interface CreateUpdatePolicyNumberModel {
    policyNumberId?: number;
    policyId?: number;
    dateCreated?: Date;
    isValid?: boolean;
    policyNumber?: string | undefined;
}

export interface CreateUpdatePaymentPlanModel {
    id?: number;
    division?: string | undefined;
    policyNumber?: string | undefined;
    group?: string | undefined;
    saveAge?: boolean;
    issueAge?: number;
    targetPremium?: number;
    deathBenefit?: number;
    spLife?: number;
    createdByUserId?: number;
    commissionTypeId?: number;
    enrollmentNumber?: string | undefined;
    appliedRatingId?: number | undefined;
    approvedRatingId?: number | undefined;
    ssboCreditCard?: boolean;
    excessAmount?: number;
    annuityAmount?: number;
    isCopy?: boolean;
}

export interface RenewalAddEditFlatRateCalcuateRequestModel {
    renewalCommissionPlanId?: number | undefined;
    renewalIssueAge?: number;
    policyProductId?: number;
    policyEffectiveDate?: Date;
    flatRateMonth?: number;
    useFlatRateMonth?: boolean;
    duration?: number;
}

export interface RenewalAddEditRequestModel {
    policyId?: number;
    renewalId?: number;
    renewalTypeId?: number;
    renewalPaymentSourceString?: string | undefined;
    flatRateFactor?: number | undefined;
    renewalPremium?: number;
    premiumOverride?: number | undefined;
    renewalAddEditFlatRateCalcuateRequestModel?: RenewalAddEditFlatRateCalcuateRequestModel;
    rowVersion?: string | undefined;
    isEditable?: boolean;
}

export interface RenewalDetailModel {
    policyNumber?: string | undefined;
    customerFirstName?: string | undefined;
    customerLastName?: string | undefined;
    carrierName?: string | undefined;
    productName?: string | undefined;
    modeName?: string | undefined;
    canProRate?: boolean;
    policyRenewalReminderNote?: string | undefined;
    proRateCaption?: string | undefined;
    renewalAddEditRequestModel?: RenewalAddEditRequestModel;
    commissionPlanLookupList?: ListItem[] | undefined;
}

export interface PoliciesForRenewalDetailsModel {
    readonly policyId?: number;
    readonly policyNumber?: string | undefined;
    readonly effectiveDate?: any | undefined;
    readonly agent?: string | undefined;
    readonly status?: string | undefined;
    readonly product?: string | undefined;
    readonly company?: string | undefined;
}

export interface RenewalFlatRateCalculationRequest {
    renewalCommissionPlanId?: number;
    renewalIssueAge?: number;
    policyProductId?: number;
    policyEffectiveDate?: Date;
    flatRateMonth?: number;
    useFlatRateMonth?: boolean;
    duration?: number;
}

export interface RenewalFlatRateCalculationResponse {
    flatRate?: number;
    resultCaption?: string | undefined;
    isEditable?: boolean;
}

export interface RenewalHistoryDetailModel {
    commissionID?: number;
    datePaid?: string | undefined;
    renewalMonth?: string | undefined;
    paid?: string | undefined;
    premium?: number;
    commission?: number;
    rate?: number;
    paidTo?: string | undefined;
    paymentSourceName?: string | undefined;
    flatRateAmount?: number;
    advance?: string | undefined;
    commissionPlanName?: string | undefined;
    statementDate?: string | undefined;
    commissionReceived?: number;
}

export interface RenewalHistoryListViewModel {
    records?: RenewalHistoryDetailModel[] | undefined;
    totalCommissionPaid?: number;
}

export interface CommissionReceivedByPolicyListModel2 {
    id?: number;
    policyId?: number;
    amount?: number;
    date?: Date;
    isEdit?: boolean;
}

export interface CommisionReceivedResponse {
    iscommissionReceivedExist?: boolean;
}

export interface CreateUpdatePolicyRenewalDetailModel {
    policyId?: number;
    renewalId?: number;
    renewalTypeId?: number;
    renewalPaymentSourceString?: string | undefined;
    flatRateFactor?: number | undefined;
    renewalPremium?: number;
    premiumOverride?: number | undefined;
    renewalCommissionPlanId?: number | undefined;
    renewalIssueAge?: number;
    duration?: number;
}

export interface PoliciesInfoRequest {
    agentId?: number;
    productId?: number;
    uplineId?: number;
    marketerIds?: number[] | undefined;
    companyId?: number;
    startDate?: Date;
    stopDate?: Date;
    policyStatuses?: number[] | undefined;
    whichDate?: string | undefined;
    leadSource?: number;
    customerState?: number;
    licenseStates?: number[] | undefined;
    homeStates?: string[] | undefined;
    categories?: number[] | undefined;
    subCategories?: number[] | undefined;
    hidePriviteNotes?: boolean;
    fileType?: FileType2;
}

export interface PoliciesSummaryRequest {
    agentId?: number;
    productId?: number;
    uplineId?: number;
    marketerIds?: number[] | undefined;
    companyId?: number;
    startDate?: Date;
    stopDate?: Date;
    policyStatuses?: number[] | undefined;
    whichDate?: string | undefined;
    leadSource?: number;
    customerState?: number;
    licenseStates?: number[] | undefined;
    homeStates?: string[] | undefined;
    categories?: number[] | undefined;
    subCategories?: number[] | undefined;
    fileType?: FileType2;
}

export interface TripStandingsRequest {
    startDate?: Date;
    stopDate?: Date;
    homeStates?: string[] | undefined;
    licenseStates?: number[] | undefined;
    uplineId?: number;
    marketerIds?: number[] | undefined;
    fileType?: FileType2;
}

export interface SingleLifePremiumListModel {
    id?: number;
    policyId?: number;
    amount?: number;
    date?: Date;
}

export interface SingleLifePremiumModel {
    id?: number;
    policyId?: number;
    amount?: number;
    date?: Date;
}

export interface CreateUpdateSingleLifePremiumModel {
    id?: number;
    policyId?: number;
    amount?: number;
    date?: Date;
    override?: number;
}

export interface TripPointsAgentSPModel {
    agentId?: number;
    tripCategoryId?: number;
    categoryName?: string | undefined;
    appCount?: number;
    annualPremium?: number;
    targetPremium?: number;
    points?: number;
    singleLife?: number;
    annuities?: number;
}

export interface TripPointsByAgentSearchResponse {
    excludeFromTrip?: boolean;
    data?: TripPointsAgentSPModel[] | undefined;
}

export interface TripPointsPolicySPModel {
    points?: number;
}

export interface TripPointsByPoliciesSearchResponse {
    policyId?: number;
    policyPointListModels?: TripPointsPolicySPModel[] | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}